import React, { useState, useEffect } from 'react';
import { collection, addDoc, query, where, getDocs, getDoc, doc, updateDoc, collectionGroup } from 'firebase/firestore';
import { db } from '../components/firebase-config.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
 fa0, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, faA, faAd, faAdd, faAddressBook, faAddressCard, faAdjust, faAirFreshener, faAlignCenter, faAlignJustify, faAlignLeft, faAlignRight, faAllergies, faAmbulance, faAmericanSignLanguageInterpreting, faAnchor, faAnchorCircleCheck, faAnchorCircleExclamation, faAnchorCircleXmark, faAnchorLock, faAngleDoubleDown, faAngleDoubleLeft, faAngleDoubleRight, faAngleDoubleUp, faAngleDown, faAngleLeft, faAngleRight, faAngleUp, faAnglesDown, faAnglesLeft, faAnglesRight, faAnglesUp, faAngry, faAnkh, faAppleAlt, faAppleWhole, faArchive, faArchway, faAreaChart, faArrowAltCircleDown, faArrowAltCircleLeft, faArrowAltCircleRight, faArrowAltCircleUp, faArrowCircleDown, faArrowCircleLeft, faArrowCircleRight, faArrowCircleUp, faArrowDown, faArrowDown19, faArrowDown91, faArrowDownAZ, faArrowDownLong, faArrowDownShortWide, faArrowDownUpAcrossLine, faArrowDownUpLock, faArrowDownWideShort, faArrowDownZA, faArrowLeft, faArrowLeftLong, faArrowLeftRotate, faArrowPointer, faArrowRight, faArrowRightArrowLeft, faArrowRightFromBracket, faArrowRightFromFile, faArrowRightLong, faArrowRightRotate, faArrowRightToBracket, faArrowRightToCity, faArrowRightToFile, faArrowRotateBack, faArrowRotateBackward, faArrowRotateForward, faArrowRotateLeft, faArrowRotateRight, faArrowTrendDown, faArrowTrendUp, faArrowTurnDown, faArrowTurnUp, faArrowUp, faArrowUp19, faArrowUp91, faArrowUpAZ, faArrowUpFromBracket, faArrowUpFromGroundWater, faArrowUpFromWaterPump, faArrowUpLong, faArrowUpRightDots, faArrowUpRightFromSquare, faArrowUpShortWide, faArrowUpWideShort, faArrowUpZA, faArrows, faArrowsAlt, faArrowsAltH, faArrowsAltV, faArrowsDownToLine, faArrowsDownToPeople, faArrowsH, faArrowsLeftRight, faArrowsLeftRightToLine, faArrowsRotate, faArrowsSpin, faArrowsSplitUpAndLeft, faArrowsToCircle, faArrowsToDot, faArrowsToEye, faArrowsTurnRight, faArrowsTurnToDots, faArrowsUpDown, faArrowsUpDownLeftRight, faArrowsUpToLine, faArrowsV, faAslInterpreting, faAssistiveListeningSystems, faAsterisk, faAt, faAtlas, faAtom, faAudioDescription, faAustralSign, faAutomobile, faAward, faB, faBaby, faBabyCarriage, faBackspace, faBackward, faBackwardFast, faBackwardStep, faBacon, faBacteria, faBacterium, faBagShopping, faBahai, faBahtSign, faBalanceScale, faBalanceScaleLeft, faBalanceScaleRight, faBan, faBanSmoking, faBandAid, faBandage, faBangladeshiTakaSign, faBank, faBarChart, faBarcode, faBars, faBarsProgress, faBarsStaggered, faBaseball, faBaseballBall, faBaseballBatBall, faBasketShopping, faBasketball, faBasketballBall, faBath, faBathtub, faBattery, faBattery0, faBattery2, faBattery3, faBattery4, faBattery5, faBatteryCar, faBatteryEmpty, faBatteryFull, faBatteryHalf, faBatteryQuarter, faBatteryThreeQuarters, faBed, faBedPulse, faBeer, faBeerMugEmpty, faBell, faBellConcierge, faBellSlash, faBezierCurve, faBible, faBicycle, faBiking, faBinoculars, faBiohazard, faBirthdayCake, faBitcoinSign, faBlackboard, faBlender, faBlenderPhone, faBlind, faBlog, faBold, faBolt, faBoltLightning, faBomb, faBone, faBong, faBook, faBookAtlas, faBookBible, faBookBookmark, faBookDead, faBookJournalWhills, faBookMedical, faBookOpen, faBookOpenReader, faBookQuran, faBookReader, faBookSkull, faBookTanakh, faBookmark, faBorderAll, faBorderNone, faBorderStyle, faBorderTopLeft, faBoreHole, faBottleDroplet, faBottleWater, faBowlFood, faBowlRice, faBowlingBall, faBox, faBoxArchive, faBoxOpen, faBoxTissue, faBoxes, faBoxesAlt, faBoxesPacking, faBoxesStacked, faBraille, faBrain, faBrazilianRealSign, faBreadSlice, faBridge, faBridgeCircleCheck, faBridgeCircleExclamation, faBridgeCircleXmark, faBridgeLock, faBridgeWater, faBriefcase, faBriefcaseClock, faBriefcaseMedical, faBroadcastTower, faBroom, faBroomBall, faBrush, faBucket, faBug, faBugSlash, faBugs, faBuilding, faBuildingCircleArrowRight, faBuildingCircleCheck, faBuildingCircleExclamation, faBuildingCircleXmark, faBuildingColumns, faBuildingFlag, faBuildingLock, faBuildingNgo, faBuildingShield, faBuildingUn, faBuildingUser, faBuildingWheat, faBullhorn, faBullseye, faBurger, faBurn, faBurst, faBus, faBusAlt, faBusSimple, faBusinessTime, faC, faCab, faCableCar, faCake, faCakeCandles, faCalculator, faCalendar, faCalendarAlt, faCalendarCheck, faCalendarDay, faCalendarDays, faCalendarMinus, faCalendarPlus, faCalendarTimes, faCalendarWeek, faCalendarXmark, faCamera, faCameraAlt, faCameraRetro, faCameraRotate, faCampground, faCancel, faCandyCane, faCannabis, faCapsules, faCar, faCarAlt, faCarBattery, faCarBurst, faCarCrash, faCarOn, faCarRear, faCarSide, faCarTunnel, faCaravan, faCaretDown, faCaretLeft, faCaretRight, faCaretSquareDown, faCaretSquareLeft, faCaretSquareRight, faCaretSquareUp, faCaretUp, faCarriageBaby, faCarrot, faCartArrowDown, faCartFlatbed, faCartFlatbedSuitcase, faCartPlus, faCartShopping, faCashRegister, faCat, faCediSign, faCentSign, faCertificate, faChain, faChainBroken, faChainSlash, faChair, faChalkboard, faChalkboardTeacher, faChalkboardUser, faChampagneGlasses, faChargingStation, faChartArea, faChartBar, faChartColumn, faChartDiagram, faChartGantt, faChartLine, faChartPie, faChartSimple, faCheck, faCheckCircle, faCheckDouble, faCheckSquare, faCheckToSlot, faCheese, faChess, faChessBishop, faChessBoard, faChessKing, faChessKnight, faChessPawn, faChessQueen, faChessRook, faChevronCircleDown, faChevronCircleLeft, faChevronCircleRight, faChevronCircleUp, faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faChild, faChildCombatant, faChildDress, faChildReaching, faChildRifle, faChildren, faChurch, faCircle, faCircleArrowDown, faCircleArrowLeft, faCircleArrowRight, faCircleArrowUp, faCircleCheck, faCircleChevronDown, faCircleChevronLeft, faCircleChevronRight, faCircleChevronUp, faCircleDollarToSlot, faCircleDot, faCircleDown, faCircleExclamation, faCircleH, faCircleHalfStroke, faCircleInfo, faCircleLeft, faCircleMinus, faCircleNodes, faCircleNotch, faCirclePause, faCirclePlay, faCirclePlus, faCircleQuestion, faCircleRadiation, faCircleRight, faCircleStop, faCircleUp, faCircleUser, faCircleXmark, faCity, faClapperboard, faClinicMedical, faClipboard, faClipboardCheck, faClipboardList, faClipboardQuestion, faClipboardUser, faClock, faClockFour, faClockRotateLeft, faClone, faClose, faClosedCaptioning, faCloud, faCloudArrowDown, faCloudArrowUp, faCloudBolt, faCloudDownload, faCloudDownloadAlt, faCloudMeatball, faCloudMoon, faCloudMoonRain, faCloudRain, faCloudShowersHeavy, faCloudShowersWater, faCloudSun, faCloudSunRain, faCloudUpload, faCloudUploadAlt, faClover, faCny, faCocktail, faCode, faCodeBranch, faCodeCommit, faCodeCompare, faCodeFork, faCodeMerge, faCodePullRequest, faCoffee, faCog, faCogs, faCoins, faColonSign, faColumns, faComment, faCommentAlt, faCommentDollar, faCommentDots, faCommentMedical, faCommentNodes, faCommentSlash, faCommentSms, faCommenting, faComments, faCommentsDollar, faCompactDisc, faCompass, faCompassDrafting, faCompress, faCompressAlt, faCompressArrowsAlt, faComputer, faComputerMouse, faConciergeBell, faContactBook, faContactCard, faCookie, faCookieBite, faCopy, faCopyright, faCouch, faCow, faCreditCard, faCreditCardAlt, faCrop, faCropAlt, faCropSimple, faCross, faCrosshairs, faCrow, faCrown, faCrutch, faCruzeiroSign, faCube, faCubes, faCubesStacked, faCut, faCutlery, faD, faDashboard, faDatabase, faDeaf, faDeafness, faDedent, faDeleteLeft, faDemocrat, faDesktop, faDesktopAlt, faDharmachakra, faDiagnoses, faDiagramNext, faDiagramPredecessor, faDiagramProject, faDiagramSuccessor, faDiamond, faDiamondTurnRight, faDice, faDiceD20, faDiceD6, faDiceFive, faDiceFour, faDiceOne, faDiceSix, faDiceThree, faDiceTwo, faDigging, faDigitalTachograph, faDirections, faDisease, faDisplay, faDivide, faDizzy, faDna, faDog, faDollar, faDollarSign, faDolly, faDollyBox, faDollyFlatbed, faDonate, faDongSign, faDoorClosed, faDoorOpen, faDotCircle, faDove, faDownLeftAndUpRightToCenter, faDownLong, faDownload, faDraftingCompass, faDragon, faDrawPolygon, faDriversLicense, faDroplet, faDropletSlash, faDrum, faDrumSteelpan, faDrumstickBite, faDumbbell, faDumpster, faDumpsterFire, faDungeon, faE, faEarDeaf, faEarListen, faEarth, faEarthAfrica, faEarthAmerica, faEarthAmericas, faEarthAsia, faEarthEurope, faEarthOceania, faEdit, faEgg, faEject, faElevator, faEllipsis, faEllipsisH, faEllipsisV, faEllipsisVertical, faEnvelope, faEnvelopeCircleCheck, faEnvelopeOpen, faEnvelopeOpenText, faEnvelopeSquare, faEnvelopesBulk, faEquals, faEraser, faEthernet, faEur, faEuro, faEuroSign, faExchange, faExchangeAlt, faExclamation, faExclamationCircle, faExclamationTriangle, faExpand, faExpandAlt, faExpandArrowsAlt, faExplosion, faExternalLink, faExternalLinkAlt, faExternalLinkSquare, faExternalLinkSquareAlt, faEye, faEyeDropper, faEyeDropperEmpty, faEyeLowVision, faEyeSlash, faEyedropper, faF, faFaceAngry, faFaceDizzy, faFaceFlushed, faFaceFrown, faFaceFrownOpen, faFaceGrimace, faFaceGrin, faFaceGrinBeam, faFaceGrinBeamSweat, faFaceGrinHearts, faFaceGrinSquint, faFaceGrinSquintTears, faFaceGrinStars, faFaceGrinTears, faFaceGrinTongue, faFaceGrinTongueSquint, faFaceGrinTongueWink, faFaceGrinWide, faFaceGrinWink, faFaceKiss, faFaceKissBeam, faFaceKissWinkHeart, faFaceLaugh, faFaceLaughBeam, faFaceLaughSquint, faFaceLaughWink, faFaceMeh, faFaceMehBlank, faFaceRollingEyes, faFaceSadCry, faFaceSadTear, faFaceSmile, faFaceSmileBeam, faFaceSmileWink, faFaceSurprise, faFaceTired, faFan, faFastBackward, faFastForward, faFaucet, faFaucetDrip, faFax, faFeather, faFeatherAlt, faFeatherPointed, faFeed, faFemale, faFerry, faFighterJet, faFile, faFileAlt, faFileArchive, faFileArrowDown, faFileArrowUp, faFileAudio, faFileCircleCheck, faFileCircleExclamation, faFileCircleMinus, faFileCirclePlus, faFileCircleQuestion, faFileCircleXmark, faFileClipboard, faFileCode, faFileContract, faFileCsv, faFileDownload, faFileEdit, faFileExcel, faFileExport, faFileFragment, faFileHalfDashed, faFileImage, faFileImport, faFileInvoice, faFileInvoiceDollar, faFileLines, faFileMedical, faFileMedicalAlt, faFilePdf, faFilePen, faFilePowerpoint, faFilePrescription, faFileShield, faFileSignature, faFileText, faFileUpload, faFileVideo, faFileWaveform, faFileWord, faFileZipper, faFill, faFillDrip, faFilm, faFilter, faFilterCircleDollar, faFilterCircleXmark, faFingerprint, faFire, faFireAlt, faFireBurner, faFireExtinguisher, faFireFlameCurved, faFireFlameSimple, faFirstAid, faFish, faFishFins, faFistRaised, faFlag, faFlagCheckered, faFlagUsa, faFlask, faFlaskVial, faFloppyDisk, faFlorinSign, faFlushed, faFolder, faFolderBlank, faFolderClosed, faFolderMinus, faFolderOpen, faFolderPlus, faFolderTree, faFont, faFontAwesome, faFontAwesomeFlag, faFontAwesomeLogoFull, faFootball, faFootballBall, faForward, faForwardFast, faForwardStep, faFrancSign, faFrog, faFrown, faFrownOpen, faFunnelDollar, faFutbol, faFutbolBall, faG, faGamepad, faGasPump, faGauge, faGaugeHigh, faGaugeMed, faGaugeSimple, faGaugeSimpleHigh, faGaugeSimpleMed, faGavel, faGbp, faGear, faGears, faGem, faGenderless, faGhost, faGift, faGifts, faGlassCheers, faGlassMartini, faGlassMartiniAlt, faGlassWater, faGlassWaterDroplet, faGlassWhiskey, faGlasses, faGlobe, faGlobeAfrica, faGlobeAmericas, faGlobeAsia, faGlobeEurope, faGlobeOceania, faGolfBall, faGolfBallTee, faGopuram, faGraduationCap, faGreaterThan, faGreaterThanEqual, faGrimace, faGrin, faGrinAlt, faGrinBeam, faGrinBeamSweat, faGrinHearts, faGrinSquint, faGrinSquintTears, faGrinStars, faGrinTears, faGrinTongue, faGrinTongueSquint, faGrinTongueWink, faGrinWink, faGrip, faGripHorizontal, faGripLines, faGripLinesVertical, faGripVertical, faGroupArrowsRotate, faGuaraniSign, faGuitar, faGun, faH, faHSquare, faHamburger, faHammer, faHamsa, faHand, faHandBackFist, faHandDots, faHandFist, faHandHolding, faHandHoldingDollar, faHandHoldingDroplet, faHandHoldingHand, faHandHoldingHeart, faHandHoldingMedical, faHandHoldingUsd, faHandHoldingWater, faHandLizard, faHandMiddleFinger, faHandPaper, faHandPeace, faHandPointDown, faHandPointLeft, faHandPointRight, faHandPointUp, faHandPointer, faHandRock, faHandScissors, faHandSparkles, faHandSpock, faHandcuffs, faHands, faHandsAmericanSignLanguageInterpreting, faHandsAslInterpreting, faHandsBound, faHandsBubbles, faHandsClapping, faHandsHelping, faHandsHolding, faHandsHoldingChild, faHandsHoldingCircle, faHandsPraying, faHandsWash, faHandshake, faHandshakeAlt, faHandshakeAltSlash, faHandshakeAngle, faHandshakeSimple, faHandshakeSimpleSlash, faHandshakeSlash, faHanukiah, faHardDrive, faHardHat, faHardOfHearing, faHashtag, faHatCowboy, faHatCowboySide, faHatHard, faHatWizard, faHaykal, faHdd, faHeadSideCough, faHeadSideCoughSlash, faHeadSideMask, faHeadSideVirus, faHeader, faHeading, faHeadphones, faHeadphonesAlt, faHeadphonesSimple, faHeadset, faHeart, faHeartBroken, faHeartCircleBolt, faHeartCircleCheck, faHeartCircleExclamation, faHeartCircleMinus, faHeartCirclePlus, faHeartCircleXmark, faHeartCrack, faHeartMusicCameraBolt, faHeartPulse, faHeartbeat, faHelicopter, faHelicopterSymbol, faHelmetSafety, faHelmetUn, faHexagonNodes, faHexagonNodesBolt, faHighlighter, faHiking, faHillAvalanche, faHillRockslide, faHippo, faHistory, faHockeyPuck, faHollyBerry, faHome, faHomeAlt, faHomeLg, faHomeLgAlt, faHomeUser, faHorse, faHorseHead, faHospital, faHospitalAlt, faHospitalSymbol, faHospitalUser, faHospitalWide, faHotTub, faHotTubPerson, faHotdog, faHotel, faHourglass, faHourglass1, faHourglass2, faHourglass3, faHourglassEmpty, faHourglassEnd, faHourglassHalf, faHourglassStart, faHouse, faHouseChimney, faHouseChimneyCrack, faHouseChimneyMedical, faHouseChimneyUser, faHouseChimneyWindow, faHouseCircleCheck, faHouseCircleExclamation, faHouseCircleXmark, faHouseCrack, faHouseDamage, faHouseFire, faHouseFlag, faHouseFloodWater, faHouseFloodWaterCircleArrowRight, faHouseLaptop, faHouseLock, faHouseMedical, faHouseMedicalCircleCheck, faHouseMedicalCircleExclamation, faHouseMedicalCircleXmark, faHouseMedicalFlag, faHouseSignal, faHouseTsunami, faHouseUser, faHryvnia, faHryvniaSign, faHurricane, faI, faICursor, faIceCream, faIcicles, faIcons, faIdBadge, faIdCard, faIdCardAlt, faIdCardClip, faIgloo, faIls, faImage, faImagePortrait, faImages, faInbox, faIndent, faIndianRupee, faIndianRupeeSign, faIndustry, faInfinity, faInfo, faInfoCircle, faInr, faInstitution, faItalic, faJ, faJar, faJarWheat, faJedi, faJetFighter, faJetFighterUp, faJoint, faJournalWhills, faJpy, faJugDetergent, faK, faKaaba, faKey, faKeyboard, faKhanda, faKipSign, faKiss, faKissBeam, faKissWinkHeart, faKitMedical, faKitchenSet, faKiwiBird, faKrw, faL, faLadderWater, faLandMineOn, faLandmark, faLandmarkAlt, faLandmarkDome, faLandmarkFlag, faLanguage, faLaptop, faLaptopCode, faLaptopFile, faLaptopHouse, faLaptopMedical, faLariSign, faLaugh, faLaughBeam, faLaughSquint, faLaughWink, faLayerGroup, faLeaf, faLeftLong, faLeftRight, faLegal, faLemon, faLessThan, faLessThanEqual, faLevelDown, faLevelDownAlt, faLevelUp, faLevelUpAlt, faLifeRing, faLightbulb, faLineChart, faLinesLeaning, faLink, faLinkSlash, faLiraSign, faList, faList12, faListAlt, faListCheck, faListDots, faListNumeric, faListOl, faListSquares, faListUl, faLitecoinSign, faLocation, faLocationArrow, faLocationCrosshairs, faLocationDot, faLocationPin, faLocationPinLock, faLock, faLockOpen, faLocust, faLongArrowAltDown, faLongArrowAltLeft, faLongArrowAltRight, faLongArrowAltUp, faLongArrowDown, faLongArrowLeft, faLongArrowRight, faLongArrowUp, faLowVision, faLuggageCart, faLungs, faLungsVirus, faM, faMagic, faMagicWandSparkles, faMagnet, faMagnifyingGlass, faMagnifyingGlassArrowRight, faMagnifyingGlassChart, faMagnifyingGlassDollar, faMagnifyingGlassLocation, faMagnifyingGlassMinus, faMagnifyingGlassPlus, faMailBulk, faMailForward, faMailReply, faMailReplyAll, faMale, faManatSign, faMap, faMapLocation, faMapLocationDot, faMapMarked, faMapMarkedAlt, faMapMarker, faMapMarkerAlt, faMapPin, faMapSigns, faMarker, faMars, faMarsAndVenus, faMarsAndVenusBurst, faMarsDouble, faMarsStroke, faMarsStrokeH, faMarsStrokeRight, faMarsStrokeUp, faMarsStrokeV, faMartiniGlass, faMartiniGlassCitrus, faMartiniGlassEmpty, faMask, faMaskFace, faMaskVentilator, faMasksTheater, faMattressPillow, faMaximize, faMedal, faMedkit, faMeh, faMehBlank, faMehRollingEyes, faMemory, faMenorah, faMercury, faMessage, faMeteor, faMicrochip, faMicrophone, faMicrophoneAlt, faMicrophoneAltSlash, faMicrophoneLines, faMicrophoneLinesSlash, faMicrophoneSlash, faMicroscope, faMillSign, faMinimize, faMinus, faMinusCircle, faMinusSquare, faMitten, faMobile, faMobileAlt, faMobileAndroid, faMobileAndroidAlt, faMobileButton, faMobilePhone, faMobileRetro, faMobileScreen, faMobileScreenButton, faMoneyBill, faMoneyBill1, faMoneyBill1Wave, faMoneyBillAlt, faMoneyBillTransfer, faMoneyBillTrendUp, faMoneyBillWave, faMoneyBillWaveAlt, faMoneyBillWheat, faMoneyBills, faMoneyCheck, faMoneyCheckAlt, faMoneyCheckDollar, faMonument, faMoon, faMortarBoard, faMortarPestle, faMosque, faMosquito, faMosquitoNet, faMotorcycle, faMound, faMountain, faMountainCity, faMountainSun, faMouse, faMousePointer, faMugHot, faMugSaucer, faMultiply, faMuseum, faMusic, faN, faNairaSign, faNavicon, faNetworkWired, faNeuter, faNewspaper, faNotEqual, faNotdef, faNoteSticky, faNotesMedical, faO, faObjectGroup, faObjectUngroup, faOilCan, faOilWell, faOm, faOtter, faOutdent, faP, faPager, faPaintBrush, faPaintRoller, faPaintbrush, faPalette, faPallet, faPanorama, faPaperPlane, faPaperclip, faParachuteBox, faParagraph, faParking, faPassport, faPastafarianism, faPaste, faPause, faPauseCircle, faPaw, faPeace, faPen, faPenAlt, faPenClip, faPenFancy, faPenNib, faPenRuler, faPenSquare, faPenToSquare, faPencil, faPencilAlt, faPencilRuler, faPencilSquare, faPeopleArrows, faPeopleArrowsLeftRight, faPeopleCarry, faPeopleCarryBox, faPeopleGroup, faPeopleLine, faPeoplePulling, faPeopleRobbery, faPeopleRoof, faPepperHot, faPercent, faPercentage, faPerson, faPersonArrowDownToLine, faPersonArrowUpFromLine, faPersonBiking, faPersonBooth, faPersonBreastfeeding, faPersonBurst, faPersonCane, faPersonChalkboard, faPersonCircleCheck, faPersonCircleExclamation, faPersonCircleMinus, faPersonCirclePlus, faPersonCircleQuestion, faPersonCircleXmark, faPersonDigging, faPersonDotsFromLine, faPersonDress, faPersonDressBurst, faPersonDrowning, faPersonFalling, faPersonFallingBurst, faPersonHalfDress, faPersonHarassing, faPersonHiking, faPersonMilitaryPointing, faPersonMilitaryRifle, faPersonMilitaryToPerson, faPersonPraying, faPersonPregnant, faPersonRays, faPersonRifle, faPersonRunning, faPersonShelter, faPersonSkating, faPersonSkiing, faPersonSkiingNordic, faPersonSnowboarding, faPersonSwimming, faPersonThroughWindow, faPersonWalking, faPersonWalkingArrowLoopLeft, faPersonWalkingArrowRight, faPersonWalkingDashedLineArrowRight, faPersonWalkingLuggage, faPersonWalkingWithCane, faPesetaSign, faPesoSign, faPhone, faPhoneAlt, faPhoneFlip, faPhoneSlash, faPhoneSquare, faPhoneSquareAlt, faPhoneVolume, faPhotoFilm, faPhotoVideo, faPieChart, faPiggyBank, faPills, faPingPongPaddleBall, faPizzaSlice, faPlaceOfWorship, faPlane, faPlaneArrival, faPlaneCircleCheck, faPlaneCircleExclamation, faPlaneCircleXmark, faPlaneDeparture, faPlaneLock, faPlaneSlash, faPlaneUp, faPlantWilt, faPlateWheat, faPlay, faPlayCircle, faPlug, faPlugCircleBolt, faPlugCircleCheck, faPlugCircleExclamation, faPlugCircleMinus, faPlugCirclePlus, faPlugCircleXmark, faPlus, faPlusCircle, faPlusMinus, faPlusSquare, faPodcast, faPoll, faPollH, faPoo, faPooBolt, faPooStorm, faPoop, faPortrait, faPoundSign, faPowerOff, faPray, faPrayingHands, faPrescription, faPrescriptionBottle, faPrescriptionBottleAlt, faPrescriptionBottleMedical, faPrint, faProcedures, faProjectDiagram, faPumpMedical, faPumpSoap, faPuzzlePiece, faQ, faQrcode, faQuestion, faQuestionCircle, faQuidditch, faQuidditchBroomBall, faQuoteLeft, faQuoteLeftAlt, faQuoteRight, faQuoteRightAlt, faQuran, faR, faRadiation, faRadiationAlt, faRadio, faRainbow, faRandom, faRankingStar, faReceipt, faRecordVinyl, faRectangleAd, faRectangleList, faRectangleTimes, faRectangleXmark, faRecycle, faRedo, faRedoAlt, faRefresh, faRegistered, faRemove, faRemoveFormat, faReorder, faRepeat, faReply, faReplyAll, faRepublican, faRestroom, faRetweet, faRibbon, faRightFromBracket, faRightLeft, faRightLong, faRightToBracket, faRing, faRmb, faRoad, faRoadBarrier, faRoadBridge, faRoadCircleCheck, faRoadCircleExclamation, faRoadCircleXmark, faRoadLock, faRoadSpikes, faRobot, faRocket, faRodAsclepius, faRodSnake, faRotate, faRotateBack, faRotateBackward, faRotateForward, faRotateLeft, faRotateRight, faRouble, faRoute, faRss, faRssSquare, faRub, faRuble, faRubleSign, faRug, faRuler, faRulerCombined, faRulerHorizontal, faRulerVertical, faRunning, faRupee, faRupeeSign, faRupiahSign, faS, faSackDollar, faSackXmark, faSadCry, faSadTear, faSailboat, faSatellite, faSatelliteDish, faSave, faScaleBalanced, faScaleUnbalanced, faScaleUnbalancedFlip, faSchool, faSchoolCircleCheck, faSchoolCircleExclamation, faSchoolCircleXmark, faSchoolFlag, faSchoolLock, faScissors, faScrewdriver, faScrewdriverWrench, faScroll, faScrollTorah, faSdCard, faSearch, faSearchDollar, faSearchLocation, faSearchMinus, faSearchPlus, faSection, faSeedling, faServer, faShapes, faShare, faShareAlt, faShareAltSquare, faShareFromSquare, faShareNodes, faShareSquare, faSheetPlastic, faShekel, faShekelSign, faSheqel, faSheqelSign, faShield, faShieldAlt, faShieldBlank, faShieldCat, faShieldDog, faShieldHalved, faShieldHeart, faShieldVirus, faShip, faShippingFast, faShirt, faShoePrints, faShop, faShopLock, faShopSlash, faShoppingBag, faShoppingBasket, faShoppingCart, faShower, faShrimp, faShuffle, faShuttleSpace, faShuttleVan, faSign, faSignHanging, faSignIn, faSignInAlt, faSignLanguage, faSignOut, faSignOutAlt, faSignal, faSignal5, faSignalPerfect, faSignature, faSigning, faSignsPost, faSimCard, faSink, faSitemap, faSkating, faSkiing, faSkiingNordic, faSkull, faSkullCrossbones, faSlash, faSleigh, faSliders, faSlidersH, faSmile, faSmileBeam, faSmileWink, faSmog, faSmoking, faSmokingBan, faSms, faSnowboarding, faSnowflake, faSnowman, faSnowplow, faSoap, faSoccerBall, faSocks, faSolarPanel, faSort, faSortAlphaAsc, faSortAlphaDesc, faSortAlphaDown, faSortAlphaDownAlt, faSortAlphaUp, faSortAlphaUpAlt, faSortAmountAsc, faSortAmountDesc, faSortAmountDown, faSortAmountDownAlt, faSortAmountUp, faSortAmountUpAlt, faSortAsc, faSortDesc, faSortDown, faSortNumericAsc, faSortNumericDesc, faSortNumericDown, faSortNumericDownAlt, faSortNumericUp, faSortNumericUpAlt, faSortUp, faSpa, faSpaceShuttle, faSpaghettiMonsterFlying, faSpellCheck, faSpider, faSpinner, faSplotch, faSpoon, faSprayCan, faSprayCanSparkles, faSprout, faSquare, faSquareArrowUpRight, faSquareBinary, faSquareCaretDown, faSquareCaretLeft, faSquareCaretRight, faSquareCaretUp, faSquareCheck, faSquareEnvelope, faSquareFull, faSquareH, faSquareMinus, faSquareNfi, faSquareParking, faSquarePen, faSquarePersonConfined, faSquarePhone, faSquarePhoneFlip, faSquarePlus, faSquarePollHorizontal, faSquarePollVertical, faSquareRootAlt, faSquareRootVariable, faSquareRss, faSquareShareNodes, faSquareUpRight, faSquareVirus, faSquareXmark, faStaffAesculapius, faStaffSnake, faStairs, faStamp, faStapler, faStar, faStarAndCrescent, faStarHalf, faStarHalfAlt, faStarHalfStroke, faStarOfDavid, faStarOfLife, faStepBackward, faStepForward, faSterlingSign, faStethoscope, faStickyNote, faStop, faStopCircle, faStopwatch, faStopwatch20, faStore, faStoreAlt, faStoreAltSlash, faStoreSlash, faStream, faStreetView, faStrikethrough, faStroopwafel, faSubscript, faSubtract, faSubway, faSuitcase, faSuitcaseMedical, faSuitcaseRolling, faSun, faSunPlantWilt, faSuperscript, faSurprise, faSwatchbook, faSwimmer, faSwimmingPool, faSynagogue, faSync, faSyncAlt, faSyringe, faT, faTShirt, faTable, faTableCells, faTableCellsColumnLock, faTableCellsLarge, faTableCellsRowLock, faTableCellsRowUnlock, faTableColumns, faTableList, faTableTennis, faTableTennisPaddleBall, faTablet, faTabletAlt, faTabletAndroid, faTabletButton, faTabletScreenButton, faTablets, faTachographDigital, faTachometer, faTachometerAlt, faTachometerAltAverage, faTachometerAltFast, faTachometerAverage, faTachometerFast, faTag, faTags, faTanakh, faTape, faTarp, faTarpDroplet, faTasks, faTasksAlt, faTaxi, faTeeth, faTeethOpen, faTeletype, faTelevision, faTemperature0, faTemperature1, faTemperature2, faTemperature3, faTemperature4, faTemperatureArrowDown, faTemperatureArrowUp, faTemperatureDown, faTemperatureEmpty, faTemperatureFull, faTemperatureHalf, faTemperatureHigh, faTemperatureLow, faTemperatureQuarter, faTemperatureThreeQuarters, faTemperatureUp, faTenge, faTengeSign, faTent, faTentArrowDownToLine, faTentArrowLeftRight, faTentArrowTurnLeft, faTentArrowsDown, faTents, faTerminal, faTextHeight, faTextSlash, faTextWidth, faTh, faThLarge, faThList, faTheaterMasks, faThermometer, faThermometer0, faThermometer1, faThermometer2, faThermometer3, faThermometer4, faThermometerEmpty, faThermometerFull, faThermometerHalf, faThermometerQuarter, faThermometerThreeQuarters, faThumbTack, faThumbTackSlash, faThumbsDown, faThumbsUp, faThumbtack, faThumbtackSlash, faThunderstorm, faTicket, faTicketAlt, faTicketSimple, faTimeline, faTimes, faTimesCircle, faTimesRectangle, faTimesSquare, faTint, faTintSlash, faTired, faToggleOff, faToggleOn, faToilet, faToiletPaper, faToiletPaperSlash, faToiletPortable, faToiletsPortable, faToolbox, faTools, faTooth, faTorah, faToriiGate, faTornado, faTowerBroadcast, faTowerCell, faTowerObservation, faTractor, faTrademark, faTrafficLight, faTrailer, faTrain, faTrainSubway, faTrainTram, faTram, faTransgender, faTransgenderAlt, faTrash, faTrashAlt, faTrashArrowUp, faTrashCan, faTrashCanArrowUp, faTrashRestore, faTrashRestoreAlt, faTree, faTreeCity, faTriangleCircleSquare, faTriangleExclamation, faTrophy, faTrowel, faTrowelBricks, faTruck, faTruckArrowRight, faTruckDroplet, faTruckFast, faTruckField, faTruckFieldUn, faTruckFront, faTruckLoading, faTruckMedical, faTruckMonster, faTruckMoving, faTruckPickup, faTruckPlane, faTruckRampBox, faTry, faTshirt, faTty, faTurkishLira, faTurkishLiraSign, faTurnDown, faTurnUp, faTv, faTvAlt, faU, faUmbrella, faUmbrellaBeach, faUnderline, faUndo, faUndoAlt, faUniversalAccess, faUniversity, faUnlink, faUnlock, faUnlockAlt, faUnlockKeyhole, faUnsorted, faUpDown, faUpDownLeftRight, faUpLong, faUpRightAndDownLeftFromCenter, faUpRightFromSquare, faUpload, faUsd, faUser, faUserAlt, faUserAltSlash, faUserAstronaut, faUserCheck, faUserCircle, faUserClock, faUserCog, faUserDoctor, faUserEdit, faUserFriends, faUserGear, faUserGraduate, faUserGroup, faUserInjured, faUserLarge, faUserLargeSlash, faUserLock, faUserMd, faUserMinus, faUserNinja, faUserNurse, faUserPen, faUserPlus, faUserSecret, faUserShield, faUserSlash, faUserTag, faUserTie, faUserTimes, faUserXmark, faUsers, faUsersBetweenLines, faUsersCog, faUsersGear, faUsersLine, faUsersRays, faUsersRectangle, faUsersSlash, faUsersViewfinder, faUtensilSpoon, faUtensils, faV, faVanShuttle, faVault, faVcard, faVectorSquare, faVenus, faVenusDouble, faVenusMars, faVest, faVestPatches, faVial, faVialCircleCheck, faVialVirus, faVials, faVideo, faVideoCamera, faVideoSlash, faVihara, faVirus, faVirusCovid, faVirusCovidSlash, faVirusSlash, faViruses, faVoicemail, faVolcano, faVolleyball, faVolleyballBall, faVolumeControlPhone, faVolumeDown, faVolumeHigh, faVolumeLow, faVolumeMute, faVolumeOff, faVolumeTimes, faVolumeUp, faVolumeXmark, faVoteYea, faVrCardboard, faW, faWalkieTalkie, faWalking, faWallet, faWandMagic, faWandMagicSparkles, faWandSparkles, faWarehouse, faWarning, faWater, faWaterLadder, faWaveSquare, faWebAwesome, faWeight, faWeightHanging, faWeightScale, faWheatAlt, faWheatAwn, faWheatAwnCircleExclamation, faWheelchair, faWheelchairAlt, faWheelchairMove, faWhiskeyGlass, faWifi, faWifi3, faWifiStrong, faWind, faWindowClose, faWindowMaximize, faWindowMinimize, faWindowRestore, faWineBottle, faWineGlass, faWineGlassAlt, faWineGlassEmpty, faWon, faWonSign, faWorm, faWrench, faX, faXRay, faXmark, faXmarkCircle, faXmarkSquare, faXmarksLines, faY, faYen, faYenSign, faYinYang, faZ, faZap, fas, prefix
} from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';

const Quick = () => {
  // État fixe de la structure qui recevra toutes les demandes
  const STRUCTURE_ID = "atneb9qRGkbzxPkMRWzRmaJD8Kw1";
  const STRUCTURE_NOM = "SEN ASSISTANCE MÉDICALE DIGITALE";

  // Configuration PayTech
  const payTechConfig = {
    api_key: "0360fc1c628c4527a6035a75d63bbd9ec2ad27da5e56b39be53019a36578c80c",
    api_secret: "3f2048b8e427fa67a3a6341bcfe3795abc05cdd68ad101d6f51ebe6734340b9c",
    env: "test",
    ipn_url: "https://www.samdigitale.com/Quick/ipn",
    success_url: "https://www.samdigitale.com/Quick",
    cancel_url: "https://www.samdigitale.com/Quick"
  };

  // Configuration Maytapi pour WhatsApp
  const maytapiConfig = {
    product_id: "5e994f76-4f49-4057-aca4-6bef3b1de795",
    api_key: "a0b5ba45-b4da-429e-ba5b-127851d9b92e",
    phone_id: "77695",
    baseUrl: "https://api.maytapi.com/api"
  };
  
  // États principaux
  const [activePanel, setActivePanel] = useState('booking');
  const [currentView, setCurrentView] = useState('booking');
  const [currentStep, setCurrentStep] = useState(1);
  const [initialView, setInitialView] = useState(true);
  
  // État du formulaire
  const [formData, setFormData] = useState({
    nom: '',
    dateNaissance: '',
    email: '',
    telephone: '',
    dateRdv: '',
    heureRdv: '',
    medecinId: '',
    motif: '',
    statut: 'confirmé',
    structureId: STRUCTURE_ID
  });

  // États pour les données
  const [age, setAge] = useState('');
  const [medecins, setMedecins] = useState([]);
  const [creneauxDisponibles, setCreneauxDisponibles] = useState([]);
  const [rendezvous, setRendezvous] = useState([]);
  const [specialites, setSpecialites] = useState([]);
  const [selectedSpecialite, setSelectedSpecialite] = useState('');
  const [allStructures, setAllStructures] = useState([]);
  const [allSpecialites, setAllSpecialites] = useState([]);
  const [selectedStructure, setSelectedStructure] = useState(STRUCTURE_ID);
  const [externalSpecialites, setExternalSpecialites] = useState([]);
  const [isExternalSpeciality, setIsExternalSpeciality] = useState(false);
  
  // États pour l'interface
  const [loading, setLoading] = useState(false);
  const [loadingMedecins, setLoadingMedecins] = useState(true);
  const [loadingStructures, setLoadingStructures] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [isMobile, setIsMobile] = useState(false);
  
  // États pour la vérification et les iframes
  const [verificationCode, setVerificationCode] = useState('');
  const [verificationSearchCode, setVerificationSearchCode] = useState('');
  const [verificationResult, setVerificationResult] = useState(null);
  const [loadingVerification, setLoadingVerification] = useState(false);
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [iframeTitle, setIframeTitle] = useState('');
  const [showHomeConsultModal, setShowHomeConsultModal] = useState(false);
  
  // États pour la modification
  const [modificationMode, setModificationMode] = useState(false);
  const [appointmentToModify, setAppointmentToModify] = useState(null);
  const [modificationStep, setModificationStep] = useState(1);
  const [cancelConfirmation, setCancelConfirmation] = useState(false);

  // Ref pour gérer les timeouts
  const timeoutRef = React.useRef(null);

  // **NOUVEAUX ÉTATS POUR LA VÉRIFICATION DU PATIENT**
  const [patientExists, setPatientExists] = useState(null);
  const [existingPatientData, setExistingPatientData] = useState(null);
  const [checkingPatient, setCheckingPatient] = useState(false);
  const [showPatientSelection, setShowPatientSelection] = useState(false);
  const [foundPatients, setFoundPatients] = useState([]);

  // Détection de l'appareil
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Cleanup pour les timeouts
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  // Chargement initial des données
  useEffect(() => {
    fetchMedecins();
    fetchRendezvous();
    fetchAllStructures();
    fetchAllSpecialites();
  }, []);

  // Calcul de la date de naissance à partir de l'âge
  useEffect(() => {
    if (age) {
      const birthDate = calculateBirthDateFromAge(age);
      setFormData(prev => ({ ...prev, dateNaissance: birthDate }));
    }
  }, [age]);

  // **NOUVELLE FONCTION : Vérification automatique du patient existant**
  const checkExistingPatient = async (telephone) => {
    if (!telephone || telephone.length < 8) {
      setPatientExists(null);
      setExistingPatientData(null);
      setShowPatientSelection(false);
      setFoundPatients([]);
      return;
    }
    
    try {
      setCheckingPatient(true);
      
      // Nettoyer le numéro de téléphone pour la recherche
      const cleanedPhone = telephone.replace(/\s+/g, '').replace(/^\+221/, '').replace(/^221/, '');
      
      // Rechercher dans les rendez-vous existants
      const rdvQuery = query(
        collection(db, 'rendezvous'),
        where("patientTelephone", "==", telephone.trim().replace(/\s+/g, ''))
      );
      
      // Rechercher aussi avec différents formats de numéro
      const rdvQuery2 = query(
        collection(db, 'rendezvous'),
        where("patientTelephone", "==", `+221${cleanedPhone}`)
      );
      
      const rdvQuery3 = query(
        collection(db, 'rendezvous'),
        where("patientTelephone", "==", cleanedPhone)
      );
      
      const [snapshot1, snapshot2, snapshot3] = await Promise.all([
        getDocs(rdvQuery),
        getDocs(rdvQuery2),
        getDocs(rdvQuery3)
      ]);
      
      const allPatients = new Map(); // Utiliser Map pour éviter les doublons
      
      // Collecter tous les patients trouvés
      [snapshot1, snapshot2, snapshot3].forEach(snapshot => {
        snapshot.forEach(doc => {
          const data = doc.data();
          const key = `${data.patientNom}-${data.patientTelephone}`;
          if (!allPatients.has(key)) {
            allPatients.set(key, {
              id: doc.id,
              nom: data.patientNom || '',
              email: data.patientEmail || '',
              telephone: data.patientTelephone || '',
              dateNaissance: data.patientDateNaissance || '',
              lastVisit: data.date || '',
              totalVisits: 1
            });
          } else {
            // Incrémenter le nombre de visites
            const existing = allPatients.get(key);
            existing.totalVisits += 1;
            if (data.date > existing.lastVisit) {
              existing.lastVisit = data.date;
            }
          }
        });
      });
      
      const patientsArray = Array.from(allPatients.values());
      
      if (patientsArray.length > 0) {
        if (patientsArray.length === 1) {
          // Un seul patient trouvé, le sélectionner automatiquement
          const patient = patientsArray[0];
          
          React.startTransition(() => {
            setExistingPatientData(patient);
            setPatientExists(true);
            setShowPatientSelection(false);
            setFoundPatients([]);
            
            // Calculer l'âge à partir de la date de naissance
            if (patient.dateNaissance) {
              const birthDate = new Date(patient.dateNaissance);
              const today = new Date();
              const calculatedAge = today.getFullYear() - birthDate.getFullYear();
              setAge(calculatedAge.toString());
            }
            
            setFormData(prev => ({
              ...prev,
              nom: patient.nom,
              email: patient.email,
              dateNaissance: patient.dateNaissance
            }));
            
            setMessage({ 
              text: `Patient trouvé ! Informations récupérées automatiquement. Dernière visite : ${formatDate(patient.lastVisit)}`, 
              type: "success" 
            });
          });
        } else {
          // Plusieurs patients trouvés, permettre la sélection
          React.startTransition(() => {
            setFoundPatients(patientsArray);
            setShowPatientSelection(true);
            setPatientExists(true);
            setExistingPatientData(null);
            setMessage({ 
              text: `${patientsArray.length} patients trouvés avec ce numéro. Veuillez sélectionner le bon profil.`, 
              type: "info" 
            });
          });
        }
      } else {
        // Aucun patient trouvé
        setPatientExists(false);
        setExistingPatientData(null);
        setMessage({ 
          text: "Nouveau patient détecté. Veuillez compléter vos informations.", 
          type: "info" 
        });
      }
    } catch (error) {
      console.error("Erreur lors de la vérification du patient:", error);
      setPatientExists(false);
      setMessage({ 
        text: "Erreur lors de la vérification. Veuillez continuer avec la saisie manuelle.", 
        type: "error" 
      });
    } finally {
      setCheckingPatient(false);
    }
  };

  // **NOUVELLE FONCTION : Sélection d'un patient existant**
  const selectExistingPatient = (patient) => {
    // Utiliser un batch update pour éviter les conflits de rendu
    React.startTransition(() => {
      setExistingPatientData(patient);
      setShowPatientSelection(false);
      setPatientExists(true);
      
      // Calculer l'âge à partir de la date de naissance
      if (patient.dateNaissance) {
        const birthDate = new Date(patient.dateNaissance);
        const today = new Date();
        const calculatedAge = today.getFullYear() - birthDate.getFullYear();
        setAge(calculatedAge.toString());
      }
      
      setFormData(prev => ({
        ...prev,
        nom: patient.nom,
        email: patient.email,
        dateNaissance: patient.dateNaissance
      }));
      
      setMessage({ 
        text: `Profil sélectionné ! Dernière visite : ${formatDate(patient.lastVisit)}`, 
        type: "success" 
      });
    });
  };

  // **NOUVELLE FONCTION : Créer un nouveau profil patient**
  const createNewPatientProfile = () => {
    React.startTransition(() => {
      setPatientExists(false);
      setExistingPatientData(null);
      setShowPatientSelection(false);
      setFoundPatients([]);
      setFormData(prev => ({
        ...prev,
        nom: '',
        email: '',
        dateNaissance: ''
      }));
      setAge('');
      setMessage({ 
        text: "Création d'un nouveau profil patient. Veuillez compléter les informations.", 
        type: "info" 
      });
    });
  };

  // Fonction pour calculer la date de naissance à partir de l'âge
  const calculateBirthDateFromAge = (ageValue) => {
    if (!ageValue || isNaN(parseInt(ageValue))) return '';
    
    const today = new Date();
    const birthYear = today.getFullYear() - parseInt(ageValue);
    const birthDate = new Date(birthYear, today.getMonth(), today.getDate());
    return birthDate.toISOString().split('T')[0]; // Format YYYY-MM-DD
  };

  // Récupération des structures
  const fetchAllStructures = async () => {
    try {
      setLoadingStructures(true);
      const structuresQuery = query(collection(db, 'structures'));
      const querySnapshot = await getDocs(structuresQuery);
      
      if (querySnapshot.empty) {
        console.log("Aucune structure trouvée dans la base de données");
        setAllStructures([]);
      } else {
        const structuresList = [];
        querySnapshot.forEach((doc) => {
          const structureData = { id: doc.id, ...doc.data() };
          structuresList.push(structureData);
        });
        setAllStructures(structuresList);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des structures:", error);
    } finally {
      setLoadingStructures(false);
    }
  };

  // Récupération des spécialités
  const fetchAllSpecialites = async () => {
    try {
      const medecinsQuery = query(collection(db, 'medecins'));
      const querySnapshot = await getDocs(medecinsQuery);
      
      if (querySnapshot.empty) {
        setAllSpecialites([]);
      } else {
        const specialitesSet = new Set();
        
        querySnapshot.forEach((doc) => {
          const medecinData = doc.data();
          if (medecinData.specialite) {
            specialitesSet.add(medecinData.specialite);
          }
        });
        
        const specialitesArray = Array.from(specialitesSet).sort();
        setAllSpecialites(specialitesArray);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des spécialités:", error);
    }
  };

  // Récupération des médecins
  const fetchMedecins = async (structureId = STRUCTURE_ID) => {
    try {
      setLoadingMedecins(true);
      const q = query(collection(db, 'medecins'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        setMessage({ 
          text: "Aucun médecin n'est disponible pour cette structure.", 
          type: "error" 
        });
        setMedecins([]);
        setSpecialites([]);
      } else {
        const medecinsList = [];
        const specialitesSet = new Set();
        
        querySnapshot.forEach((doc) => {
          const medecinData = { id: doc.id, ...doc.data() };
          medecinsList.push(medecinData);
          
          if (medecinData.specialite) {
            specialitesSet.add(medecinData.specialite);
          }
        });
        
        setMedecins(medecinsList);
        setSpecialites(Array.from(specialitesSet).sort());
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des médecins:", error);
      setMessage({ 
        text: "Impossible de charger les médecins. Veuillez réessayer plus tard.", 
        type: "error" 
      });
    } finally {
      setLoadingMedecins(false);
    }
  };

  // Récupération des rendez-vous
  const fetchRendezvous = async (structureId = STRUCTURE_ID) => {
    try {
      const q = query(collection(db, 'rendezvous'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      
      const rdvList = [];
      querySnapshot.forEach((doc) => {
        rdvList.push({ id: doc.id, ...doc.data() });
      });
      setRendezvous(rdvList);
    } catch (error) {
      console.error("Erreur lors de la récupération des rendez-vous:", error);
    }
  };

  // Recherche des structures avec une spécialité spécifique
  const findStructuresWithSpeciality = async (specialite) => {
    try {
      setLoadingMedecins(true);
      const q = query(collection(db, 'medecins'), where("specialite", "==", specialite));
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        return [];
      } else {
        const structuresSet = new Set();
        const structuresList = [];
        
        querySnapshot.forEach((doc) => {
          const medecinData = doc.data();
          if (medecinData.structureId && !structuresSet.has(medecinData.structureId)) {
            structuresSet.add(medecinData.structureId);
            
            const structure = allStructures.find(s => s.id === medecinData.structureId);
            if (structure) {
              structuresList.push(structure);
            }
          }
        });
        
        return structuresList;
      }
    } catch (error) {
      console.error("Erreur lors de la recherche des structures:", error);
      return [];
    } finally {
      setLoadingMedecins(false);
    }
  };

  // Vérification de la disponibilité
  const verifierDisponibilite = (medecinId, date, heure) => {
    const medecin = medecins.find(m => m.id === medecinId);
    if (!medecin) return false;
    
    const jourDate = new Date(date);
    const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    const jourSemaine = joursMap[jourDate.getDay()];
    
    let disponibiliteJour = null;
    if (Array.isArray(medecin.disponibilites)) {
      disponibiliteJour = medecin.disponibilites.find(d => 
        d.jour.toLowerCase() === jourSemaine.toLowerCase()
      );
    } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
      disponibiliteJour = medecin.disponibilites[jourSemaine].actif ? {
        heureDebut: medecin.disponibilites[jourSemaine].debut,
        heureFin: medecin.disponibilites[jourSemaine].fin
      } : null;
    }
    
    if (!disponibiliteJour) return false;
    
    const heureDebut = disponibiliteJour.heureDebut || disponibiliteJour.debut;
    const heureFin = disponibiliteJour.heureFin || disponibiliteJour.fin;
    
    if (heure < heureDebut || heure > heureFin) return false;
    
    const dureeFixe = 15;
    const [heureH, heureM] = heure.split(':').map(Number);
    const heureFinRdv = new Date();
    heureFinRdv.setHours(heureH, heureM + dureeFixe, 0, 0);
    const heureFinStr = `${heureFinRdv.getHours().toString().padStart(2, '0')}:${heureFinRdv.getMinutes().toString().padStart(2, '0')}`;
    
    if (heureFinStr > heureFin) return false;
    
    const rdvDuJour = rendezvous.filter(rdv => 
      rdv.medecinId === medecinId && 
      rdv.date === date && 
      rdv.statut !== 'annulé'
    );
    
    const rdvAuCreneau = rdvDuJour.filter(rdv => rdv.heure === heure);
    
    const MAX_RDV_SIMULTANES = 3;
    
    if (rdvAuCreneau.length >= MAX_RDV_SIMULTANES) {
      return false;
    }
    
    return true;
  };

  // Obtention des créneaux disponibles
  const getCreneauxAvecStatut = () => {
    if (!formData.medecinId || !formData.dateRdv) return [];
    
    const medecin = medecins.find(m => m.id === formData.medecinId);
    if (!medecin) return [];
    
    const jourDate = new Date(formData.dateRdv);
    const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    const jourSemaine = joursMap[jourDate.getDay()];
    
    let heureDebut = '08:00';
    let heureFin = '18:00';
    let disponibiliteJour = null;
    
    if (Array.isArray(medecin.disponibilites)) {
      disponibiliteJour = medecin.disponibilites.find(d => 
        d.jour.toLowerCase() === jourSemaine.toLowerCase()
      );
      
      if (disponibiliteJour) {
        heureDebut = disponibiliteJour.heureDebut;
        heureFin = disponibiliteJour.heureFin;
      } else {
        return [];
      }
    } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
      if (!medecin.disponibilites[jourSemaine].actif) {
        return [];
      }
      heureDebut = medecin.disponibilites[jourSemaine].debut;
      heureFin = medecin.disponibilites[jourSemaine].fin;
    } else {
      return [];
    }
    
    const rdvDuJour = rendezvous.filter(rdv => 
      rdv.medecinId === formData.medecinId && 
      rdv.date === formData.dateRdv && 
      rdv.statut !== 'annulé'
    );
    
    const tousLesCreneaux = [];
    let heure = heureDebut;
    
    const MAX_RDV_SIMULTANES = 3;
    const dureeFixe = 15;
    
    while (heure < heureFin) {
      const [h, m] = heure.split(':').map(Number);
      const heureFinCreneau = new Date();
      heureFinCreneau.setHours(h, m + dureeFixe, 0, 0);
      const heureFinStr = `${heureFinCreneau.getHours().toString().padStart(2, '0')}:${heureFinCreneau.getMinutes().toString().padStart(2, '0')}`;
      
      if (heureFinStr <= heureFin) {
        const rdvAuCreneau = rdvDuJour.filter(rdv => rdv.heure === heure);
        const nombreRdvAuCreneau = rdvAuCreneau.length;
        
        let ajustementNombre = 0;
        if (modificationMode && appointmentToModify && appointmentToModify.heure === heure && appointmentToModify.date === formData.dateRdv) {
          ajustementNombre = 1;
        }
        
        let statut = 'disponible';
        if (nombreRdvAuCreneau - ajustementNombre >= MAX_RDV_SIMULTANES) {
          statut = 'complet';
        } else if (nombreRdvAuCreneau > 0) {
          statut = 'partiel';
        }
        
        tousLesCreneaux.push({
          heure: heure,
          statut: statut,
          nombreRdv: nombreRdvAuCreneau - ajustementNombre,
          estDisponible: statut !== 'complet'
        });
      }
      
      const nextHeure = new Date();
      nextHeure.setHours(h, m + 15, 0, 0);
      heure = `${nextHeure.getHours().toString().padStart(2, '0')}:${nextHeure.getMinutes().toString().padStart(2, '0')}`;
    }
    
    return tousLesCreneaux;
  };

  // Génération d'un code de vérification
  const generateVerificationCode = () => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let code = '';
    for (let i = 0; i < 8; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  };

  // **GESTION MODIFIÉE DES CHANGEMENTS DANS LE FORMULAIRE**
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // **Vérification automatique du patient lors de la saisie du téléphone**
    if (name === 'telephone') {
      // Réinitialiser les états si le numéro est court
      if (value.length < 8) {
        setPatientExists(null);
        setExistingPatientData(null);
        setShowPatientSelection(false);
        setFoundPatients([]);
      } else {
        // Nettoyer le timeout précédent
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        
        // Debounce pour éviter trop d'appels
        timeoutRef.current = setTimeout(() => {
          checkExistingPatient(value);
        }, 1000);
      }
    }
    
    if (name === 'medecinId' || name === 'dateRdv') {
      // Utiliser un setTimeout pour éviter les conflits d'état
      setTimeout(() => {
        if ((name === 'dateRdv' && formData.medecinId && value) || 
            (name === 'medecinId' && value && formData.dateRdv)) {
          const creneaux = getCreneauxAvecStatut();
          setCreneauxDisponibles(creneaux);
        }
      }, 0);
    }
  };

  // Gestion du changement d'âge
  const handleAgeChange = (e) => {
    const ageValue = e.target.value;
    setAge(ageValue);
  };

  // Validation du formulaire
  const isFormValid = () => {
    const requiredFields = ['telephone', 'dateRdv', 'heureRdv', 'medecinId'];
    return requiredFields.every(field => formData[field]);
  };

  // Validation de l'étape courante
  const isCurrentStepValid = () => {
    switch (currentStep) {
      case 1:
        return formData.telephone;
      case 2:
        return  formData.dateRdv;
    
      default:
        return false;
    }
  };

 // Navigation entre les étapes
const handleNextStep = () => {
  if (isCurrentStepValid()) {
    if (currentStep === 2) {
      const creneaux = getCreneauxAvecStatut();
      setCreneauxDisponibles(creneaux);
    }
    setCurrentStep(currentStep + 1);
  } else {
    let errorMessage = "";
    switch (currentStep) {
      case 1:
        errorMessage = "Veuillez saisir votre numéro de téléphone.";
        break;
      case 2:
        errorMessage = "Veuillez sélectionner une date de rendez-vous.";
        break;
      default:
        errorMessage = "Veuillez remplir tous les champs obligatoires.";
    }
    setMessage({ text: errorMessage, type: "error" });
  }
};


  const handlePrevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  // Formatage de la date
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };

  // Gestion du changement de spécialité
  const handleSpecialiteChange = async (e) => {
    const value = e.target.value;
    setSelectedSpecialite(value);
    
    if (value === 'domicile') {
      const domicileUrl = "https://sen-amd.vercel.app";
      setIframeUrl(domicileUrl);
      setIframeTitle("Consultation à domicile");
      setShowIframe(true);
      setIsExternalSpeciality(false);
    } else if (value) {
      const isLocalSpeciality = specialites.includes(value);
      
      if (isLocalSpeciality) {
        setIsExternalSpeciality(false);
        setSelectedStructure(STRUCTURE_ID);
        setFormData(prev => ({ ...prev, medecinId: '', structureId: STRUCTURE_ID }));
      } else {
        setIsExternalSpeciality(true);
        const structuresWithSpeciality = await findStructuresWithSpeciality(value);
        
        if (structuresWithSpeciality.length > 0) {
          setExternalSpecialites(structuresWithSpeciality);
          setMessage({ 
            text: `La spécialité "${value}" est disponible dans ${structuresWithSpeciality.length} autre(s) structure(s).`, 
            type: "info" 
          });
        } else {
          setExternalSpecialites([]);
          setMessage({ 
            text: `Aucune structure ne propose actuellement la spécialité "${value}".`, 
            type: "error" 
          });
        }
        
        setFormData(prev => ({ ...prev, medecinId: '' }));
      }
    }
  };

  // Gestion du changement de structure
  const handleStructureChange = async (e) => {
    const structureId = e.target.value;
    setSelectedStructure(structureId);
    
    setFormData(prev => ({ ...prev, structureId: structureId, medecinId: '' }));
    
    await fetchMedecins(structureId);
    await fetchRendezvous(structureId);
    
    const structure = allStructures.find(s => s.id === structureId);
    if (structure) {
      setMessage({ 
        text: `Vous consultez maintenant les médecins de la structure: ${structure.nom}`, 
        type: "info" 
      });
    }
  };

  // Soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (modificationMode && appointmentToModify) {
      return saveModifications(e);
    }
    
    if (!formData.telephone || !formData.dateRdv) {
      setMessage({ text: "Veuillez remplir tous les champs obligatoires", type: "error" });
      return;
    }
    
    try {
      setLoading(true);
      
      const code = generateVerificationCode();
      setVerificationCode(code);
      
      const medecin = medecins.find(m => m.id === formData.medecinId);
      
      let structureNom = STRUCTURE_NOM;
      let structureId = formData.structureId;
      
      if (structureId !== STRUCTURE_ID) {
        const structure = allStructures.find(s => s.id === structureId);
        if (structure) {
          structureNom = structure.nom;
        }
      }
      
      const dateObj = new Date(formData.dateRdv);
      const formattedDate = dateObj.toISOString().split('T')[0];
      
      const createdAt = new Date();

      const patientData = {
        nom: formData.nom.trim(),
        dateNaissance: formData.dateNaissance,
        email: formData.email ? formData.email.trim() : '',
        telephone: formData.telephone.trim().replace(/\s+/g, ''),
        structureId: structureId,
        createdAt: createdAt,
        updatedAt: createdAt,
        assurances: [],
        adresse: '',
        sexe: '',
        profession: '',
        antecedents: {
          medicaux: [],
          chirurgicaux: [],
          familiaux: [],
          allergies: []
        }
      };
      
      const rdvData = {
        patientNom: formData.nom.trim(),
        patientDateNaissance: formData.dateNaissance,
        patientEmail: formData.email ? formData.email.trim() : '',
        patientTelephone: formData.telephone.trim().replace(/\s+/g, ''),
        date: formattedDate,
        heure: formData.heureRdv,
        motif: formData.motif,
        statut: formData.statut,
        medecinId: formData.medecinId,
        medecinNom: medecin?.nom || '',
        medecinSpecialite: medecin?.specialite || '',
        structureId: structureId,
        structureNom: structureNom,
        verificationCode: code,
        createdAt: createdAt,
        updatedAt: createdAt,
        // **NOUVEAU : Indicateur si c'est un patient existant**
        isExistingPatient: patientExists === true,
        patientProfileId: existingPatientData?.id || null
      };
      
      const docRef = await addDoc(collection(db, 'rendezvous'), rdvData);
      console.log("Rendez-vous enregistré avec ID: ", docRef.id);
      
      setRendezvous([...rendezvous, { id: docRef.id, ...rdvData }]);
      
      const whatsappMessage = prepareAppointmentMessage(formData, code);
      
      sendWhatsAppMessage(formData.telephone, whatsappMessage)
        .then(success => {
          if (success) {
            console.log("Message WhatsApp envoyé avec succès");
          } else {
            console.warn("L'envoi du message WhatsApp a échoué");
          }
        })
        .catch(error => {
          console.error("Erreur lors de l'envoi du message WhatsApp:", error);
        });
      
      setMessage({ text: "Rendez-vous enregistré avec succès", type: "success" });
      
      setCurrentView('success');
      
    } catch (error) {
      console.error("Erreur lors de l'enregistrement du rendez-vous:", error);
      setMessage({ 
        text: "Une erreur est survenue lors de l'enregistrement du rendez-vous", 
        type: "error" 
      });
    } finally {
      setLoading(false);
    }
  };

  // Vérification d'un rendez-vous
  const handleVerifyAppointment = async () => {
    if (!verificationSearchCode) {
      setMessage({ text: "Veuillez entrer un code de vérification", type: "error" });
      return;
    }
    
    try {
      setLoadingVerification(true);
      
      const q = query(
        collection(db, 'rendezvous'), 
        where("verificationCode", "==", verificationSearchCode.trim())
      );
      
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        setVerificationResult(null);
        setMessage({ text: "Aucun rendez-vous trouvé avec ce code", type: "error" });
      } else {
        const rdvData = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
        setVerificationResult(rdvData);
        setMessage({ text: "Rendez-vous trouvé", type: "success" });
      }
    } catch (error) {
      console.error("Erreur lors de la vérification du rendez-vous:", error);
      setMessage({ 
        text: "Une erreur est survenue lors de la vérification du rendez-vous", 
        type: "error" 
      });
    } finally {
      setLoadingVerification(false);
    }
  };

   // Recherche d'un rendez-vous pour modification
   const handleFindAppointmentForModification = async () => {
    if (!verificationSearchCode) {
      setMessage({ text: "Veuillez entrer un code de vérification", type: "error" });
      return;
    }
    
    try {
      setLoadingVerification(true);
      
      const q = query(
        collection(db, 'rendezvous'), 
        where("verificationCode", "==", verificationSearchCode.trim())
      );
      
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        setVerificationResult(null);
        setMessage({ text: "Aucun rendez-vous trouvé avec ce code", type: "error" });
      } else {
        const rdvData = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
        
        const rdvDate = new Date(rdvData.date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        
        if (rdvData.statut === 'annulé') {
          setVerificationResult(rdvData);
          setMessage({ text: "Ce rendez-vous a déjà été annulé et ne peut pas être modifié", type: "error" });
        } else if (rdvDate < today) {
          setVerificationResult(rdvData);
          setMessage({ text: "Les rendez-vous passés ne peuvent pas être modifiés", type: "error" });
        } else {
          setVerificationResult(rdvData);
          setAppointmentToModify(rdvData);
          setMessage({ text: "Rendez-vous trouvé. Vous pouvez maintenant le modifier ou l'annuler", type: "success" });
        }
      }
    } catch (error) {
      console.error("Erreur lors de la recherche du rendez-vous:", error);
      setMessage({ 
        text: "Une erreur est survenue lors de la recherche du rendez-vous", 
        type: "error" 
      });
    } finally {
      setLoadingVerification(false);
    }
  };

  // Démarrage de la modification d'un rendez-vous
  const startModification = () => {
    if (!appointmentToModify) return;
    
    setFormData({
      nom: appointmentToModify.patientNom || '',
      dateNaissance: appointmentToModify.patientDateNaissance || '',
      email: appointmentToModify.patientEmail || '',
      telephone: appointmentToModify.patientTelephone || '',
      dateRdv: appointmentToModify.date || '',
      heureRdv: appointmentToModify.heure || '',
      medecinId: appointmentToModify.medecinId || '',
      motif: appointmentToModify.motif || '',
      statut: 'confirmé',
      structureId: appointmentToModify.structureId || STRUCTURE_ID
    });
    
    fetchMedecins(appointmentToModify.structureId);
    
    if (appointmentToModify.date && appointmentToModify.medecinId) {
      const creneaux = getCreneauxAvecStatut();
      setCreneauxDisponibles(creneaux);
    }
    
    setModificationMode(true);
    setCurrentView('booking');
    setCurrentStep(2);
  };

  // Annulation d'un rendez-vous
  const cancelAppointment = async () => {
    if (!appointmentToModify) return;
    
    try {
      setLoading(true);
      
      const rdvRef = doc(db, 'rendezvous', appointmentToModify.id);
      await updateDoc(rdvRef, {
        statut: 'annulé',
        updatedAt: new Date()
      });
      
      setAppointmentToModify({...appointmentToModify, statut: 'annulé'});
      setVerificationResult({...verificationResult, statut: 'annulé'});
      
      const whatsappMessage = `🏥 *Annulation de rendez-vous - ${STRUCTURE_NOM}* 🏥\n\n` +
        `Bonjour ${appointmentToModify.patientNom || ''},\n\n` +
        `Votre rendez-vous a été annulé avec succès. Voici un rappel des détails:\n\n` +
        `📅 *Date*: ${formatDate(appointmentToModify.date)}\n` +
        `🕒 *Heure*: ${appointmentToModify.heure}\n` +
        `👨‍⚕️ *Médecin*: ${appointmentToModify.medecinTitre || "Dr"} ${appointmentToModify.medecinNom || ''}\n` +
        `🔬 *Spécialité*: ${appointmentToModify.medecinSpecialite || ''}\n\n` +
        `Si vous souhaitez reprendre rendez-vous ultérieurement, n'hésitez pas à utiliser notre plateforme.\n\n` +
        `Pour toute question, contactez-nous au +221 77 123 45 67.\n\n` +
        `À bientôt,\n` +
        `L'équipe de ${STRUCTURE_NOM}`;
      
      sendWhatsAppMessage(appointmentToModify.patientTelephone, whatsappMessage)
        .then(success => {
          if (success) {
            console.log("Message WhatsApp d'annulation envoyé avec succès");
          } else {
            console.warn("L'envoi du message WhatsApp d'annulation a échoué");
          }
        })
        .catch(error => {
          console.error("Erreur lors de l'envoi du message WhatsApp d'annulation:", error);
        });
      
      setMessage({ text: "Votre rendez-vous a été annulé avec succès", type: "success" });
      setCancelConfirmation(false);
      
    } catch (error) {
      console.error("Erreur lors de l'annulation du rendez-vous:", error);
      setMessage({ 
        text: "Une erreur est survenue lors de l'annulation du rendez-vous", 
        type: "error" 
      });
    } finally {
      setLoading(false);
    }
  };

  // Enregistrement des modifications d'un rendez-vous
  const saveModifications = async (e) => {
    e.preventDefault();
    
    if (!appointmentToModify) return;
    
    if (!formData.dateRdv || !formData.heureRdv || !formData.medecinId) {
      setMessage({ text: "Veuillez remplir tous les champs obligatoires", type: "error" });
      return;
    }
    
    try {
      setLoading(true);
      
      const medecin = medecins.find(m => m.id === formData.medecinId);
      
      const rdvRef = doc(db, 'rendezvous', appointmentToModify.id);
      await updateDoc(rdvRef, {
        date: formData.dateRdv,
        heure: formData.heureRdv,
        motif: formData.motif,
        medecinId: formData.medecinId,
        medecinNom: medecin?.nom || '',
        medecinSpecialite: medecin?.specialite || '',
        updatedAt: new Date()
      });
      
      const updatedAppointment = {
        ...appointmentToModify,
        date: formData.dateRdv,
        heure: formData.heureRdv,
        motif: formData.motif,
        medecinId: formData.medecinId,
        medecinNom: medecin?.nom || '',
        medecinSpecialite: medecin?.specialite || ''
      };
      
      setAppointmentToModify(updatedAppointment);
      setVerificationResult(updatedAppointment);
      
      const whatsappMessage = `🏥 *Modification de rendez-vous - ${STRUCTURE_NOM}* 🏥\n\n` +
        `Bonjour  ${updatedAppointment.patientNom || ''},\n\n` +
        `Votre rendez-vous a été modifié avec succès. Voici les nouveaux détails:\n\n` +
        `📅 *Date*: ${formatDate(formData.dateRdv)}\n` +
        `🕒 *Heure*: ${formData.heureRdv}\n` +
        `👨‍⚕️ *Médecin*: ${medecin?.titre || "Dr"} ${medecin?.nom || ''}\n` +
        `🔬 *Spécialité*: ${medecin?.specialite || ''}\n` +
        `📝 *Motif*: ${formData.motif || ''}\n\n` +
        `Votre code de vérification reste: *${updatedAppointment.verificationCode}*\n\n` +
        `Pour toute question, n'hésitez pas à nous contacter au +221 77 123 45 67.\n\n` +
        `À bientôt,\n` +
        `L'équipe de ${STRUCTURE_NOM}`;
      
      sendWhatsAppMessage(updatedAppointment.patientTelephone, whatsappMessage)
        .then(success => {
          if (success) {
            console.log("Message WhatsApp de modification envoyé avec succès");
          } else {
            console.warn("L'envoi du message WhatsApp de modification a échoué");
          }
        })
        .catch(error => {
          console.error("Erreur lors de l'envoi du message WhatsApp de modification:", error);
        });
      
      setMessage({ text: "Votre rendez-vous a été modifié avec succès", type: "success" });
      
      setModificationMode(false);
      setCurrentView('verification');
      
    } catch (error) {
      console.error("Erreur lors de la modification du rendez-vous:", error);
      setMessage({ 
        text: "Une erreur est survenue lors de la modification du rendez-vous", 
        type: "error" 
      });
    } finally {
      setLoading(false);
    }
  };

  // Envoi d'un message WhatsApp via Maytapi
  const sendWhatsAppMessage = async (phoneNumber, message) => {
    try {
      let formattedNumber = phoneNumber.replace(/\s+/g, '');
      if (!formattedNumber.startsWith('+')) {
        if (formattedNumber.startsWith('0')) {
          formattedNumber = '+221' + formattedNumber.substring(1);
        } else if (!formattedNumber.startsWith('221')) {
          formattedNumber = '+221' + formattedNumber;
        } else if (formattedNumber.startsWith('221')) {
          formattedNumber = '+' + formattedNumber;
        }
      }

      const url = `${maytapiConfig.baseUrl}/${maytapiConfig.product_id}/${maytapiConfig.phone_id}/sendMessage`;
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-maytapi-key': maytapiConfig.api_key
        },
        body: JSON.stringify({
          to_number: formattedNumber,
          type: 'text',
          message: message
        })
      });

      const data = await response.json();
      
      if (data.success) {
        console.log("Message WhatsApp envoyé avec succès");
        return true;
      } else {
        console.error("Erreur lors de l'envoi du message WhatsApp:", data);
        return false;
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi du message WhatsApp:", error);
      return false;
    }
  };

  // Préparation du message de confirmation de rendez-vous
  const prepareAppointmentMessage = (appointmentData, code) => {
    const medecin = medecins.find(m => m.id === appointmentData.medecinId);
    const date = formatDate(appointmentData.dateRdv);
    
    return `🏥 *Confirmation de rendez-vous - ${STRUCTURE_NOM}* 🏥\n\n` +
           `Bonjour  ${appointmentData.nom || ''},\n\n` +
           `Votre rendez-vous a été confirmé avec les détails suivants:\n\n` +
           `📅 *Date*: ${date}\n` +
           `🕒 *Heure*: ${appointmentData.heureRdv}\n` +
           `👨‍⚕️ *Médecin*: ${medecin?.titre || "Dr"} ${medecin?.nom || ''}\n` +
           `🔬 *Spécialité*: ${medecin?.specialite || ''}\n` +
           `📝 *Motif*: ${appointmentData.motif || ''}\n\n` +
           `Votre code de vérification est: *${code}*\n\n` +
           `Conservez ce code pour vérifier, modifier ou annuler votre rendez-vous.\n\n` +
           `Pour toute question, n'hésitez pas à nous contacter au +221770977918.\n\n` +
           `À bientôt,\n` +
           `L'équipe de ${STRUCTURE_NOM}`;
  };

  // Styles CSS modernisés (identiques au code précédent)
  const styles = {
    container: {
      fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
      color: "#323130",
      backgroundColor: "#f8f8f8",
      minHeight: "100vh",
      padding: "0",
      margin: "0",
      boxSizing: "border-box"
    },
    appWrapper: {
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "20px",
      backgroundColor: "#fff",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
      borderRadius: "8px"
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 0",
      marginBottom: "24px",
      borderBottom: "1px solid #edebe9"
    },
    headerTitle: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      margin: "0"
    },
    headerTitleIcon: {
      color: "#0078d4",
      fontSize: "24px"
    },
    headerTitleText: {
      fontSize: "24px",
      fontWeight: "600",
      margin: "0"
    },
    headerTitleSpan: {
      color: "#0078d4",
      fontWeight: "700"
    },
    headerLinks: {
      display: "flex",
      gap: "16px"
    },
    headerLink: {
      color: "#0078d4",
      textDecoration: "none",
      display: "flex",
      alignItems: "center",
      fontSize: "16px",
      transition: "color 0.2s ease"
    },
    alert: {
      position: "relative",
      padding: "16px",
      marginBottom: "20px",
      borderRadius: "4px",
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      animation: "fadeIn 0.3s ease"
    },
    alertSuccess: {
      backgroundColor: "#dff6dd",
      color: "#107c10",
      border: "1px solid #c3e6cb"
    },
    alertError: {
      backgroundColor: "#fed9cc",
      color: "#d83b01",
      border: "1px solid #f8d7da"
    },
    alertInfo: {
      backgroundColor: "#deecf9",
      color: "#0078d4",
      border: "1px solid #bee5eb"
    },
    alertIcon: {
      fontSize: "18px",
      marginTop: "2px"
    },
    alertContent: {
      flex: "1"
    },
    alertCloseButton: {
      background: "none",
      border: "none",
      color: "inherit",
      padding: "0",
      fontSize: "16px",
      cursor: "pointer",
      opacity: "0.7",
      transition: "opacity 0.2s ease"
    },
    mainContent: {
      padding: "10px 0"
    },
    card: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      overflow: "hidden",
      marginBottom: "24px"
    },
    cardHeader: {
      padding: "20px",
      borderBottom: "1px solid #edebe9"
    },
    cardTitle: {
      fontSize: "20px",
      fontWeight: "600",
      margin: "0",
      display: "flex",
      alignItems: "center",
      gap: "10px"
    },
    cardIcon: {
      color: "#0078d4"
    },
    cardBody: {
      padding: "20px"
    },
    stepIndicators: {
      display: "flex",
      justifyContent: "space-between",
      margin: "24px 0 32px",
      position: "relative"
    },
    stepLine: {
      position: "absolute",
      top: "12px",
      left: "10%",
      right: "10%",
      height: "2px",
      backgroundColor: "#edebe9",
      zIndex: "1"
    },
    stepItem: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      position: "relative",
      zIndex: "2"
    },
    stepCircle: {
      width: "26px",
      height: "26px",
      borderRadius: "50%",
      backgroundColor: "#fff",
      border: "2px solid #edebe9",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "8px",
      fontWeight: "600",
      fontSize: "14px",
      transition: "all 0.3s ease"
    },
    stepCircleActive: {
      backgroundColor: "#0078d4",
      border: "2px solid #0078d4",
      color: "#fff"
    },
    stepCircleCompleted: {
      backgroundColor: "#107c10",
      border: "2px solid #107c10",
      color: "#fff"
    },
    stepText: {
      fontSize: "13px",
      color: "#605e5c",
      textAlign: "center"
    },
    formGroup: {
      marginBottom: "20px"
    },
    formRow: {
      display: "flex",
      gap: "16px",
      marginBottom: "16px"
    },
    formColumn: {
      flex: "1",
      minWidth: "0"
    },
    inputWrapper: {
      position: "relative",
      marginBottom: "8px"
    },
    input: {
      width: "100%",
      padding: "10px 12px",
      fontSize: "14px",
      border: "1px solid #8a8886",
      borderRadius: "4px",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
      backgroundColor: "#fff"
    },
    inputFocus: {
      outline: "none",
      borderColor: "#0078d4",
      boxShadow: "0 0 0 2px rgba(0, 120, 212, 0.2)"
    },
    inputLabel: {
      display: "block",
      marginBottom: "6px",
      fontSize: "14px",
      fontWeight: "500",
      color: "#323130"
    },
    inputRequired: {
      color: "#d83b01"
    },
    select: {
      width: "100%",
      padding: "10px 12px",
      fontSize: "14px",
      border: "1px solid #8a8886",
      borderRadius: "4px",
      backgroundColor: "#fff",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3E%3Cpath fill='%23323130' d='M8 10.293l-4.146-4.147-.708.708L8 11.707l4.854-4.853-.708-.708L8 10.293z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 10px center",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease"
    },
    loadingIndicator: {
      display: "inline-flex",
      alignItems: "center",
      gap: "8px",
      fontSize: "14px",
      color: "#605e5c",
      marginTop: "8px"
    },
    loadingSpinner: {
      display: "inline-block",
      width: "16px",
      height: "16px",
      border: "2px solid rgba(0, 120, 212, 0.2)",
      borderRadius: "50%",
      borderTop: "2px solid #0078d4",
      animation: "spin 1s linear infinite"
    },
    textarea: {
      width: "100%",
      padding: "10px 12px",
      fontSize: "14px",
      border: "1px solid #8a8886",
      borderRadius: "4px",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease",
      resize: "vertical",
      minHeight: "120px",
      backgroundColor: "#fff"
    },
    infoBox: {
      backgroundColor: "#deecf9",
      border: "1px solid #c7e0f4",
      borderRadius: "4px",
      padding: "16px",
      marginBottom: "20px",
      display: "flex",
      gap: "12px"
    },
    infoBoxIcon: {
      color: "#0078d4",
      fontSize: "20px",
      marginTop: "2px"
    },
    infoBoxContent: {
      flex: "1"
    },
    infoBoxTitle: {
      margin: "0 0 8px 0",
      fontSize: "16px",
      fontWeight: "600"
    },
    infoBoxText: {
      margin: "0",
      fontSize: "14px"
    },
    timeSlotGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
      gap: "10px",
      marginTop: "12px"
    },
    timeSlot: {
      padding: "10px",
      border: "1px solid #edebe9",
      borderRadius: "4px",
      textAlign: "center",
      cursor: "pointer",
      transition: "all 0.2s ease",
      backgroundColor: "#fff",
      position: "relative"
    },
    timeSlotSelected: {
      backgroundColor: "#deecf9",
      borderColor: "#0078d4",
      boxShadow: "0 0 0 1px #0078d4"
    },
    timeSlotDisabled: {
      backgroundColor: "#f3f2f1",
      color: "#a19f9d",
      cursor: "not-allowed"
    },
    timeSlotPartial: {
      backgroundColor: "#fff",
      borderColor: "#ffaa44"
    },
    timeSlotBadge: {
      position: "absolute",
      top: "-8px",
      right: "-8px",
      backgroundColor: "#ffaa44",
      color: "#fff",
      borderRadius: "50%",
      width: "20px",
      height: "20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "12px",
      fontWeight: "600"
    },
    summaryCard: {
      backgroundColor: "#f8f8f8",
      borderRadius: "4px",
      padding: "16px",
      marginBottom: "16px"
    },
    summaryCardHeader: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginBottom: "12px"
    },
    summaryCardIcon: {
      width: "32px",
      height: "32px",
      borderRadius: "50%",
      backgroundColor: "#0078d4",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    summaryCardTitle: {
      margin: "0",
      fontSize: "16px",
      fontWeight: "600"
    },
    summaryList: {
      margin: "0",
      padding: "0",
      listStyle: "none"
    },
    summaryItem: {
      display: "flex",
      justifyContent: "space-between",
      padding: "8px 0",
      borderBottom: "1px solid #edebe9",
      fontSize: "14px"
    },
    summaryItemLast: {
      borderBottom: "none"
    },
    verificationCodeDisplay: {
      display: "flex",
      justifyContent: "center",
      gap: "6px",
      margin: "16px 0"
    },
    verificationCodeChar: {
      width: "36px",
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f3f2f1",
      borderRadius: "4px",
      fontSize: "18px",
      fontWeight: "600",
      fontFamily: "monospace"
    },
    paymentOptions: {
      marginTop: "16px"
    },
    paymentOption: {
      display: "flex",
      alignItems: "center",
      padding: "12px",
      border: "1px solid #edebe9",
      borderRadius: "4px",
      marginBottom: "10px",
      cursor: "pointer",
      transition: "background-color 0.2s ease"
    },
    paymentOptionSelected: {
      backgroundColor: "#deecf9",
      borderColor: "#0078d4"
    },
    paymentOptionDisabled: {
      opacity: "0.6",
      cursor: "not-allowed"
    },
    paymentOptionRadio: {
      marginRight: "12px"
    },
    paymentOptionIcon: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      backgroundColor: "#f3f2f1",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "12px",
      color: "#0078d4"
    },
    paymentOptionContent: {
      flex: "1"
    },
    paymentOptionTitle: {
      margin: "0",
      fontSize: "14px",
      fontWeight: "600"
    },
    paymentOptionDescription: {
      margin: "4px 0 0 0",
      fontSize: "12px",
      color: "#605e5c"
    },
    buttonGroup: {
      display: "flex",
      justifyContent: "space-between",
      marginTop: "24px"
    },
    buttonLeft: {
      display: "flex",
      gap: "8px"
    },
    buttonRight: {
      display: "flex",
      gap: "8px"
    },
    button: {
      padding: "8px 16px",
      fontSize: "14px",
      fontWeight: "600",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "6px",
      transition: "all 0.2s ease"
    },
    buttonPrimary: {
      backgroundColor: "#0078d4",
      color: "#fff"
    },
    buttonPrimaryHover: {
      backgroundColor: "#106ebe"
    },
    buttonSecondary: {
      backgroundColor: "#fff",
      color: "#0078d4",
      border: "1px solid #0078d4"
    },
    buttonSecondaryHover: {
      backgroundColor: "#deecf9"
    },
    buttonDanger: {
      backgroundColor: "#d83b01",
      color: "#fff"
    },
    buttonDangerHover: {
      backgroundColor: "#a80000"
    },
    buttonDisabled: {
      opacity: "0.6",
      cursor: "not-allowed"
    },
    successIcon: {
      width: "64px",
      height: "64px",
      borderRadius: "50%",
      backgroundColor: "#107c10",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "32px",
      margin: "0 auto 24px"
    },
    successTitle: {
      fontSize: "24px",
      fontWeight: "600",
      textAlign: "center",
      margin: "0 0 16px"
    },
    successMessage: {
      fontSize: "16px",
      textAlign: "center",
      margin: "0 0 24px",
      color: "#605e5c"
    },
    verificationInput: {
      display: "flex",
      gap: "8px",
      marginTop: "16px"
    },
    verificationInputField: {
      flex: "1",
      padding: "10px 12px",
      fontSize: "14px",
      border: "1px solid #8a8886",
      borderRadius: "4px",
      transition: "border-color 0.2s ease, box-shadow 0.2s ease"
    },
    verificationButton: {
      padding: "0 20px",
      backgroundColor: "#0078d4",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      fontWeight: "600",
      cursor: "pointer",
      transition: "background-color 0.2s ease"
    },
    verificationButtonHover: {
      backgroundColor: "#106ebe"
    },
    modalOverlay: {
      position: "fixed",
      top: "0",
      left: "0",
      right: "0",
      bottom: "0",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: "1000"
    },
    modalContent: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      width: "90%",
      maxWidth: "500px",
      maxHeight: "90vh",
      overflow: "auto"
    },
    modalHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 20px",
      borderBottom: "1px solid #edebe9"
    },
    modalTitle: {
      margin: "0",
      fontSize: "18px",
      fontWeight: "600"
    },
    modalCloseButton: {
      background: "none",
      border: "none",
      fontSize: "20px",
      cursor: "pointer",
      color: "#605e5c",
      padding: "0",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      transition: "background-color 0.2s ease"
    },
    modalCloseButtonHover: {
      backgroundColor: "#f3f2f1"
    },
    modalBody: {
      padding: "20px"
    },
    iframe: {
      width: "100%",
      height: "70vh",
      border: "none"
    },
    initialViewCards: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
      gap: "20px",
      marginTop: "24px"
    },
    initialViewCard: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
      overflow: "hidden",
      transition: "transform 0.2s ease, box-shadow 0.2s ease",
      cursor: "pointer",
      display: "flex",
      flexDirection: "column"
    },
    initialViewCardHover: {
      transform: "translateY(-4px)",
      boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)"
    },
    initialViewCardContent: {
      padding: "24px",
      flex: "1",
      display: "flex",
      flexDirection: "column",
      gap: "16px"
    },
    initialViewCardIcon: {
      width: "48px",
      height: "48px",
      borderRadius: "8px",
      backgroundColor: "#deecf9",
      color: "#0078d4",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "24px"
    },
    initialViewCardTitle: {
      margin: "0",
      fontSize: "18px",
      fontWeight: "600"
    },
    initialViewCardDescription: {
      margin: "0",
      fontSize: "14px",
      color: "#605e5c",
      lineHeight: "1.5"
    },
    initialViewCardButton: {
      padding: "12px",
      backgroundColor: "#f8f8f8",
      borderTop: "1px solid #edebe9",
      textAlign: "center",
      fontWeight: "600",
      color: "#0078d4",
      transition: "background-color 0.2s ease"
    },
    initialViewCardButtonHover: {
      backgroundColor: "#deecf9"
    },
    appointmentDetails: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "16px",
      marginTop: "16px"
    },
    confirmDialog: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      padding: "20px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
      marginTop: "16px"
    },
    confirmDialogHeader: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      marginBottom: "16px"
    },
    confirmDialogIcon: {
      color: "#d83b01"
    },
    confirmDialogTitle: {
      margin: "0",
      fontSize: "16px",
      fontWeight: "600"
    },
    confirmDialogButtons: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "8px",
      marginTop: "16px"
    },
    // **NOUVEAUX STYLES POUR LA SÉLECTION DE PATIENT**
    patientSelectionCard: {
      backgroundColor: "#fff",
      border: "1px solid #edebe9",
      borderRadius: "8px",
      padding: "16px",
      marginBottom: "12px",
      cursor: "pointer",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      gap: "12px"
    },
    patientSelectionCardHover: {
      backgroundColor: "#f8f8f8",
      borderColor: "#0078d4",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)"
    },
    patientAvatar: {
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      backgroundColor: "#deecf9",
      color: "#0078d4",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "20px",
      fontWeight: "600"
    },
    patientInfo: {
      flex: "1"
    },
    patientName: {
      margin: "0 0 4px 0",
      fontSize: "16px",
      fontWeight: "600",
      color: "#323130"
    },
    patientDetails: {
      margin: "0",
      fontSize: "14px",
      color: "#605e5c"
    },
    patientStats: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: "4px"
    },
    patientVisits: {
      fontSize: "12px",
      color: "#0078d4",
      fontWeight: "500"
    },
    patientLastVisit: {
      fontSize: "12px",
      color: "#605e5c"
    },
    existingPatientBanner: {
      backgroundColor: "#dff6dd",
      border: "1px solid #c3e6cb",
      borderRadius: "4px",
      padding: "12px",
      marginBottom: "16px",
      display: "flex",
      alignItems: "center",
      gap: "10px"
    },
    existingPatientIcon: {
      color: "#107c10",
      fontSize: "20px"
    },
    existingPatientText: {
      flex: "1",
      margin: "0",
      fontSize: "14px",
      color: "#107c10"
    },
    '@keyframes fadeIn': {
      from: { opacity: 0 },
      to: { opacity: 1 }
    },
    '@keyframes spin': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' }
    }
  };

  // **NOUVEAU COMPOSANT : Sélection de patient existant**
  const renderPatientSelection = () => {
    return (
      <div style={styles.card}>
        <div style={styles.cardBody}>
          <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "0 0 16px", display: "flex", alignItems: "center", gap: "8px" }}>
            <FontAwesomeIcon icon={faUserCheck} style={{ color: "#0078d4" }} />
            Sélectionner votre profil patient
          </h4>
          
          <p style={{ fontSize: "14px", color: "#605e5c", margin: "0 0 20px" }}>
            Plusieurs profils ont été trouvés avec ce numéro de téléphone. Veuillez sélectionner le vôtre :
          </p>
          
          <div style={{ marginBottom: "20px" }}>
            {foundPatients.map((patient, index) => (
              <div
              key={`patient-${patient.telephone}-${patient.nom}-${index}`}
              style={styles.patientSelectionCard}
                onClick={() => selectExistingPatient(patient)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = styles.patientSelectionCardHover.backgroundColor;
                  e.currentTarget.style.borderColor = styles.patientSelectionCardHover.borderColor;
                  e.currentTarget.style.boxShadow = styles.patientSelectionCardHover.boxShadow;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = styles.patientSelectionCard.backgroundColor;
                  e.currentTarget.style.borderColor = styles.patientSelectionCard.border.split(' ')[2];
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <div style={styles.patientAvatar}>
                  {patient.nom ? patient.nom.charAt(0).toUpperCase() : 'P'}
                </div>
                <div style={styles.patientInfo}>
                  <h5 style={styles.patientName}>
                    {patient.nom || 'Patient sans nom'}
                  </h5>
                  <p style={styles.patientDetails}>
                    {patient.telephone}
                    {patient.email && ` • ${patient.email}`}
                  </p>
                </div>
                <div style={styles.patientStats}>
                  <span style={styles.patientVisits}>
                    {patient.totalVisits} visite{patient.totalVisits > 1 ? 's' : ''}
                  </span>
                  <span style={styles.patientLastVisit}>
                    Dernière : {formatDate(patient.lastVisit)}
                  </span>
                </div>
              </div>
            ))}
          </div>
          
          <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
            <button
              onClick={createNewPatientProfile}
              style={{
                ...styles.button,
                ...styles.buttonSecondary
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = styles.buttonSecondaryHover.backgroundColor;
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = styles.buttonSecondary.backgroundColor;
              }}
            >
              <FontAwesomeIcon icon={faUserPlus} />
              Créer un nouveau profil
            </button>
          </div>
        </div>
      </div>
    );
  };

  // COMPOSANTS D'INTERFACE UTILISATEUR MODERNISÉS

  // Vue d'accueil initiale
  const renderInitialView = () => {
    return (
      <div style={styles.mainContent}>
        <div style={styles.card}>
          <div style={styles.cardBody}>
            <h3 style={{ fontSize: "24px", fontWeight: "600", margin: "0 0 16px" }}>Services de rendez-vous médicaux</h3>
            <p style={{ fontSize: "16px", color: "#605e5c", margin: "0 0 24px" }}>Que souhaitez-vous faire aujourd'hui ?</p>
            
            <div style={styles.initialViewCards}>
              <div 
                style={styles.initialViewCard}
                onClick={() => {
                  setInitialView(false);
                  setCurrentView('booking');
                  // **Réinitialiser les états de vérification patient**
                  setPatientExists(null);
                  setExistingPatientData(null);
                  setShowPatientSelection(false);
                  setFoundPatients([]);
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = styles.initialViewCardHover.transform;
                  e.currentTarget.style.boxShadow = styles.initialViewCardHover.boxShadow;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.boxShadow = styles.initialViewCard.boxShadow;
                }}
              >
                <div style={styles.initialViewCardContent}>
                  <div style={styles.initialViewCardIcon}>
                    <FontAwesomeIcon icon={faCalendarPlus} />
                  </div>
                  <h4 style={styles.initialViewCardTitle}>Prendre un rendez-vous</h4>
                  <p style={styles.initialViewCardDescription}>Réservez une consultation avec l'un de nos médecins spécialistes</p>
                </div>
                <div 
                  style={styles.initialViewCardButton}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = styles.initialViewCardButtonHover.backgroundColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = styles.initialViewCardButton.backgroundColor;
                  }}
                >
                  Commencer
                </div>
              </div>
              
              <div 
                style={styles.initialViewCard}
                onClick={() => {
                  setInitialView(false);
                  setCurrentView('verification');
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = styles.initialViewCardHover.transform;
                  e.currentTarget.style.boxShadow = styles.initialViewCardHover.boxShadow;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "none";
                  e.currentTarget.style.boxShadow = styles.initialViewCard.boxShadow;
                }}
              >
                <div style={styles.initialViewCardContent}>
                  <div style={styles.initialViewCardIcon}>
                    <FontAwesomeIcon icon={faSearch} />
                  </div>
                  <h4 style={styles.initialViewCardTitle}>Gérer mes rendez-vous</h4>
                  <p style={styles.initialViewCardDescription}>Consultez, modifiez ou annulez un rendez-vous existant</p>
                </div>
                <div 
                  style={styles.initialViewCardButton}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = styles.initialViewCardButtonHover.backgroundColor;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = styles.initialViewCardButton.backgroundColor;
                  }}
                >
                  Vérifier
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Formulaire de rendez-vous modernisé avec vérification patient
  const renderBookingForm = () => {
    // **Afficher la sélection de patient si nécessaire**
    if (showPatientSelection && foundPatients.length > 0) {
      return renderPatientSelection();
    }

    return (
      <div style={styles.card}>
        <div style={styles.cardBody}>
          <h3 style={{ fontSize: "22px", fontWeight: "600", margin: "0 0 24px" }}>
            {modificationMode ? "Modifier votre rendez-vous" : "Prendre rendez-vous"}
          </h3>
          
          {/* **Banner pour patient existant** */}
          {patientExists === true && existingPatientData && !showPatientSelection && (
            <div style={styles.existingPatientBanner}>
              <FontAwesomeIcon icon={faUserCheck} style={styles.existingPatientIcon} />
              <p style={styles.existingPatientText}>
                <strong>Patient reconnu !</strong> Vos informations ont été récupérées automatiquement. 
                Dernière visite : {formatDate(existingPatientData.lastVisit)}
              </p>
            </div>
          )}
          
          {/* Indicateurs d'étapes */}
          <div style={styles.stepIndicators}>
            <div style={styles.stepLine}></div>
            <div style={styles.stepItem}>
              <div 
                style={{
                  ...styles.stepCircle,
                  ...(currentStep > 1 ? styles.stepCircleCompleted : currentStep === 1 ? styles.stepCircleActive : {})
                }}
              >
                {currentStep > 1 ? <FontAwesomeIcon icon={faCheck} /> : 1}
              </div>
              <div style={styles.stepText}>Patient</div>
            </div>
            <div style={styles.stepItem}>
              <div 
                style={{
                  ...styles.stepCircle,
                  ...(currentStep > 2 ? styles.stepCircleCompleted : currentStep === 2 ? styles.stepCircleActive : {})
                }}
              >
                {currentStep > 2 ? <FontAwesomeIcon icon={faCheck} /> : 2}
              </div>
              <div style={styles.stepText}>Médecin & Date</div>
            </div>
           
            <div style={styles.stepItem}>
              <div 
                style={{
                  ...styles.stepCircle,
                  ...(currentStep === 3 ? styles.stepCircleActive : {})
                }}
              >
                3
              </div>
              <div style={styles.stepText}>Confirmation</div>
            </div>
          </div>
          
          <form onSubmit={handleSubmit}>
            {/* Étape 1: Informations du patient */}
            {currentStep === 1 && (
              <div style={styles.formGroup}>
                <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "0 0 20px", display: "flex", alignItems: "center", gap: "8px" }}>
                  <FontAwesomeIcon icon={faUser} style={{ color: "#0078d4" }} />
                  Informations du patient
                </h4>
                
                <div style={styles.formRow}>
                  <div style={styles.formColumn}>
                    <div style={styles.inputWrapper}>
                      <label style={styles.inputLabel} htmlFor="telephone">
                        Téléphone <span style={styles.inputRequired}>(Obligatoire)</span>
                      </label>
                      <input
                        type="tel"
                        id="telephone"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleChange}
                        placeholder="77 123 45 67"
                        required
                        style={styles.input}
                        onFocus={(e) => {
                          e.target.style.borderColor = styles.inputFocus.borderColor;
                          e.target.style.boxShadow = styles.inputFocus.boxShadow;
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = styles.input.border.split(' ')[2];
                          e.target.style.boxShadow = "none";
                        }}
                      />
                      {/* **Indicateur de vérification en cours** */}
                      {checkingPatient && (
                        <div style={styles.loadingIndicator}>
                          <div style={styles.loadingSpinner}></div>
                          <span>Vérification du patient...</span>
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={styles.formColumn}>
                    <div style={styles.inputWrapper}>
                      <label style={styles.inputLabel} htmlFor="nom">
                        Prénom et Nom (Optionnel)
                        {patientExists === false && <span style={styles.inputRequired}> *</span>}
                      </label>
                      <input
                        type="text"
                        id="nom"
                        name="nom"
                        value={formData.nom}
                        onChange={handleChange}
                        placeholder="Nom complet"
                        style={{
                          ...styles.input,
                          backgroundColor: patientExists === true ? "#f3f2f1" : "#fff"
                        }}
                        readOnly={patientExists === true}
                        required={patientExists === false}
                        onFocus={(e) => {
                          if (patientExists !== true) {
                            e.target.style.borderColor = styles.inputFocus.borderColor;
                            e.target.style.boxShadow = styles.inputFocus.boxShadow;
                          }
                        }}
                        onBlur={(e) => {
                          if (patientExists !== true) {
                            e.target.style.borderColor = styles.input.border.split(' ')[2];
                            e.target.style.boxShadow = "none";
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                
                <div style={styles.formRow}>
                  <div style={styles.formColumn}>
                    <div style={styles.inputWrapper}>
                      <label style={styles.inputLabel} htmlFor="age">Âge (Optionnel)</label>
                      <input
                        type="number"
                        id="age"
                        name="age"
                        value={age}
                        onChange={handleAgeChange}
                        placeholder="Âge en années"
                        min="0"
                        max="120"
                        style={{
                          ...styles.input,
                          backgroundColor: patientExists === true ? "#f3f2f1" : "#fff"
                        }}
                        readOnly={patientExists === true}
                        onFocus={(e) => {
                          if (patientExists !== true) {
                            e.target.style.borderColor = styles.inputFocus.borderColor;
                            e.target.style.boxShadow = styles.inputFocus.boxShadow;
                          }
                        }}
                        onBlur={(e) => {
                          if (patientExists !== true) {
                            e.target.style.borderColor = styles.input.border.split(' ')[2];
                            e.target.style.boxShadow = "none";
                          }
                        }}
                      />
                    </div>
                  </div>
                  
                  <div style={styles.formColumn}>
                    <div style={styles.inputWrapper}>
                      <label style={styles.inputLabel} htmlFor="email">Email (Optionnel)</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="exemple@email.com"
                        style={{
                          ...styles.input,
                          backgroundColor: patientExists === true ? "#f3f2f1" : "#fff"
                        }}
                        readOnly={patientExists === true}
                        onFocus={(e) => {
                          if (patientExists !== true) {
                            e.target.style.borderColor = styles.inputFocus.borderColor;
                            e.target.style.boxShadow = styles.inputFocus.boxShadow;
                          }
                        }}
                        onBlur={(e) => {
                          if (patientExists !== true) {
                            e.target.style.borderColor = styles.input.border.split(' ')[2];
                            e.target.style.boxShadow = "none";
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>

                {/* **Bouton pour créer un nouveau profil si patient existant** */}
                {patientExists === true && existingPatientData && (
                  <div style={{ marginTop: "16px", textAlign: "center" }}>
                    <button
                      type="button"
                      onClick={createNewPatientProfile}
                      style={{
                        ...styles.button,
                        ...styles.buttonSecondary,
                        fontSize: "12px",
                        padding: "6px 12px"
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.backgroundColor = styles.buttonSecondaryHover.backgroundColor;
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.backgroundColor = styles.buttonSecondary.backgroundColor;
                      }}
                    >
                      <FontAwesomeIcon icon={faUserPlus} />
                      Ce n'est pas moi, créer un nouveau profil
                    </button>
                  </div>
                )}
              </div>
            )}
            
            {/* Étape 2: Choix du médecin et de la date */}
            {currentStep === 2 && (
              <div style={styles.formGroup}>
                <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "0 0 20px", display: "flex", alignItems: "center", gap: "8px" }}>
                  <FontAwesomeIcon icon={faUserMd} style={{ color: "#0078d4" }} />
                  Choix du médecin et de la date
                </h4>
                
                <div style={styles.formRow}>
                  <div style={styles.formColumn}>
                    <div style={styles.inputWrapper}>
                      <label style={styles.inputLabel} htmlFor="specialite">Spécialité recherchée (Optionnel)</label>
                      <select
                        id="specialite"
                        value={selectedSpecialite}
                        onChange={handleSpecialiteChange}
                        style={styles.select}
                        onFocus={(e) => {
                          e.target.style.borderColor = styles.inputFocus.borderColor;
                          e.target.style.boxShadow = styles.inputFocus.boxShadow;
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = styles.input.border.split(' ')[2];
                          e.target.style.boxShadow = "none";
                        }}
                      >
                        <option value="">Sélectionner une spécialité</option>
                        <option value="domicile">Consultation à domicile</option>
                        {specialites.map((specialite, index) => (
                          <option key={`specialite-${index}-${specialite}`} value={specialite}>{specialite}</option>
                        ))}
                      {/*
                        {allSpecialites
                          .filter(spec => !specialites.includes(spec))
                          .map((specialite, index) => (
                            <option key={`ext-${index}`} value={specialite}>
                              {specialite} (externe)
                            </option>
                          ))
                        }
                        */}
                      </select>
                    </div>
                  </div>
                </div>
               

               {/*
                
                {isExternalSpeciality && externalSpecialites.length > 0 && (
                  <div style={styles.infoBox}>
                    <div style={styles.infoBoxIcon}>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </div>
                    <div style={styles.infoBoxContent}>
                      <h5 style={styles.infoBoxTitle}>Spécialité externe</h5>
                      <p style={styles.infoBoxText}>Cette spécialité est disponible dans d'autres structures. Veuillez en sélectionner une.</p>
                      
                      <div style={{ marginTop: "12px" }}>
                        <select
                          id="externalStructure"
                          value={selectedStructure}
                          onChange={handleStructureChange}
                          style={styles.select}
                          onFocus={(e) => {
                            e.target.style.borderColor = styles.inputFocus.borderColor;
                            e.target.style.boxShadow = styles.inputFocus.boxShadow;
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = styles.input.border.split(' ')[2];
                            e.target.style.boxShadow = "none";
                          }}
                        >
                          <option value="">Sélectionner une structure</option>
                          {externalSpecialites.map((structure, index) => (
                            <option key={index} value={structure.id}>
                              {structure.nom} {structure.adresse ? `- ${structure.adresse}` : ''}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
               */}
                
                <div style={styles.formRow}>
                  <div style={styles.formColumn}>
                    <div style={styles.inputWrapper}>
                      <label style={styles.inputLabel} htmlFor="medecinId">
                        Médecin <span > (Optionnel)</span>
                      </label>
                      <select
                        id="medecinId"
                        name="medecinId"
                        value={formData.medecinId}
                        onChange={handleChange}
                        disabled={loadingMedecins}
                        style={styles.select}
                        onFocus={(e) => {
                          e.target.style.borderColor = styles.inputFocus.borderColor;
                          e.target.style.boxShadow = styles.inputFocus.boxShadow;
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = styles.input.border.split(' ')[2];
                          e.target.style.boxShadow = "none";
                        }}
                      >
                        <option value="">Sélectionner un médecin</option>
                        {medecins
                          .filter(m => !selectedSpecialite || m.specialite === selectedSpecialite)
                          .map((medecin) => (
                            <option key={`medecin-${medecin.id}`} value={medecin.id}>
                              {medecin.titre || "Dr"} {medecin.nom} - {medecin.specialite}
                            </option>
                          ))
                        }
                      </select>
                      
                      {loadingMedecins && (
                        <div style={styles.loadingIndicator}>
                          <div style={styles.loadingSpinner}></div>
                          <span>Chargement des médecins...</span>
                        </div>
                      )}
                    </div>
                  </div>
                  
                  <div style={styles.formColumn}>
                    <div style={styles.inputWrapper}>
                      <label style={styles.inputLabel} htmlFor="dateRdv">
                        Date du rendez-vous <span style={styles.inputRequired}>(Obligatoire)</span>
                      </label>
                      <input
                        type="date"
                        id="dateRdv"
                        name="dateRdv"
                        value={formData.dateRdv}
                        onChange={handleChange}
                        min={new Date().toISOString().split('T')[0]}
                        required
                        style={styles.input}
                        onFocus={(e) => {
                          e.target.style.borderColor = styles.inputFocus.borderColor;
                          e.target.style.boxShadow = styles.inputFocus.boxShadow;
                        }}
                        onBlur={(e) => {
                          e.target.style.borderColor = styles.input.border.split(' ')[2];
                          e.target.style.boxShadow = "none";
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div style={styles.formGroup}>
                <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "0 0 20px", display: "flex", alignItems: "center", gap: "8px" }}>
                  <FontAwesomeIcon icon={faClock} style={{ color: "#0078d4" }} />
                  Choix de l'heure et du motif
                </h4>
                
                  <label style={styles.inputLabel}>
                    Heure du rendez-vous <span >(Optionnel)</span>
                  </label>
                  
                  {creneauxDisponibles.length > 0 ? (
                    <div style={styles.timeSlotGrid}>
                      {creneauxDisponibles.map((creneau, index) => (
                        <div 
                          key={`slot-${formData.dateRdv || 'nodate'}-${formData.medecinId || 'nomedecin'}-${creneau.heure}-${index}`} 
                          onClick={() => {
                            if (creneau.estDisponible) {
                              setFormData({ ...formData, heureRdv: creneau.heure });
                            }
                          }}
                          style={{
                            ...styles.timeSlot,
                            ...(formData.heureRdv === creneau.heure ? styles.timeSlotSelected : {}),
                            ...(creneau.statut === 'complet' ? styles.timeSlotDisabled : {}),
                            ...(creneau.statut === 'partiel' ? styles.timeSlotPartial : {})
                          }}
                        >
                          {creneau.heure}
                          {creneau.statut === 'partiel' && (
                            <div style={styles.timeSlotBadge}>
                              {creneau.nombreRdv}/3
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div style={styles.infoBox}>
                      <div style={styles.infoBoxIcon}>
                        <FontAwesomeIcon icon={faInfoCircle} />
                      </div>
                      <div style={styles.infoBoxContent}>
                        <h5 style={styles.infoBoxTitle}>Aucun créneau disponible</h5>
                        <p style={styles.infoBoxText}>Veuillez sélectionner une autre date ou un autre médecin.</p>
                      </div>
                    </div>
                  )}
                </div>
                
                <div style={styles.formGroup}>
                  <label style={styles.inputLabel} htmlFor="motif">
                    Motif de la consultation <span >(Optionnel)</span>
                  </label>
                  <textarea
                    id="motif"
                    name="motif"
                    value={formData.motif}
                    onChange={handleChange}
                    placeholder="Décrivez brièvement le motif de votre consultation"
                    style={styles.textarea}
                    onFocus={(e) => {
                      e.target.style.borderColor = styles.inputFocus.borderColor;
                      e.target.style.boxShadow = styles.inputFocus.boxShadow;
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = styles.input.border.split(' ')[2];
                      e.target.style.boxShadow = "none";
                    }}
                  ></textarea>
              </div>
              </div>

            )}
         
            
            {/* Étape 3: Confirmation */}
            {currentStep === 3 && (
              <div style={styles.formGroup}>
                <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "0 0 20px", display: "flex", alignItems: "center", gap: "8px" }}>
                  <FontAwesomeIcon icon={faClipboardList} style={{ color: "#0078d4" }} />
                  Résumé de votre rendez-vous
                </h4>
                
                <div style={styles.appointmentDetails}>
                  <div style={styles.summaryCard}>
                    <div style={styles.summaryCardHeader}>
                      <div style={styles.summaryCardIcon}>
                        <FontAwesomeIcon icon={patientExists === true ? faUserCheck : faUser} />
                      </div>
                      <h5 style={styles.summaryCardTitle}>
                        Informations du patient
                        {patientExists === true && (
                          <span style={{ fontSize: "12px", color: "#107c10", marginLeft: "8px" }}>
                            (Patient existant)
                          </span>
                        )}
                      </h5>
                    </div>
                    <ul style={styles.summaryList}>
                      <li style={styles.summaryItem}>
                        <strong>Nom:</strong> {formData.nom || '-'}
                      </li>
                      <li style={styles.summaryItem}>
                        <strong>Téléphone:</strong> {formData.telephone}
                      </li>
                      {formData.email && (
                        <li style={styles.summaryItem}>
                          <strong>Email:</strong> {formData.email}
                        </li>
                      )}
                      {formData.dateNaissance && (
                        <li style={{...styles.summaryItem, ...styles.summaryItemLast}}>
                          <strong>Date de naissance:</strong> {formatDate(formData.dateNaissance)}
                        </li>
                      )}
                      {patientExists === true && existingPatientData && (
                        <li style={{...styles.summaryItem, ...styles.summaryItemLast}}>
                          <strong>Historique:</strong> {existingPatientData.totalVisits} visite{existingPatientData.totalVisits > 1 ? 's' : ''} précédente{existingPatientData.totalVisits > 1 ? 's' : ''}
                        </li>
                      )}
                    </ul>
                  </div>
                  
                  <div style={styles.summaryCard}>
                    <div style={styles.summaryCardHeader}>
                      <div style={styles.summaryCardIcon}>
                        <FontAwesomeIcon icon={faCalendarCheck} />
                      </div>
                      <h5 style={styles.summaryCardTitle}>Détails du rendez-vous</h5>
                    </div>
                    <ul style={styles.summaryList}>
                      <li style={styles.summaryItem}>
                        <strong>Médecin:</strong> {medecins.find(m => m.id === formData.medecinId)?.titre || "Dr"} {medecins.find(m => m.id === formData.medecinId)?.nom || ''}
                      </li>
                      <li style={styles.summaryItem}>
                        <strong>Spécialité:</strong> {medecins.find(m => m.id === formData.medecinId)?.specialite || ''}
                      </li>
                      <li style={styles.summaryItem}>
                        <strong>Date:</strong> {formatDate(formData.dateRdv)}
                      </li>
                      <li style={styles.summaryItem}>
                        <strong>Heure:</strong> {formData.heureRdv}
                      </li>
                      <li style={{...styles.summaryItem, ...styles.summaryItemLast}}>
                        <strong>Motif:</strong> {formData.motif}
                      </li>
                    </ul>
                    
                    {selectedStructure !== STRUCTURE_ID && (
                      <div style={{ marginTop: "12px", display: "flex", alignItems: "center", gap: "8px" }}>
                        <FontAwesomeIcon icon={faMapMarkerAlt} style={{ color: "#0078d4" }} />
                        <div>
                          <strong>Structure:</strong> {allStructures.find(s => s.id === selectedStructure)?.nom || ''}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                
                <div style={styles.formGroup}>
                  <div style={styles.summaryCard}>
                    <div style={styles.summaryCardHeader}>
                      <div style={styles.summaryCardIcon}>
                        <FontAwesomeIcon icon={faCreditCard} />
                      </div>
                      <h5 style={styles.summaryCardTitle}>Options de paiement</h5>
                    </div>
                    
                    <div style={styles.paymentOptions}>
                      <div 
                        style={{
                          ...styles.paymentOption,
                          ...styles.paymentOptionSelected
                        }}
                      >
                        <input
                          type="radio"
                          name="paymentOption"
                          id="paymentCash"
                          value="cash"
                          defaultChecked
                          style={styles.paymentOptionRadio}
                        />
                        <div style={styles.paymentOptionIcon}>
                          <FontAwesomeIcon icon={faMoneyBillWave} />
                        </div>
                        <div style={styles.paymentOptionContent}>
                          <h5 style={styles.paymentOptionTitle}>Paiement sur place</h5>
                          <small style={styles.paymentOptionDescription}>Réglez votre consultation directement à l'accueil</small>
                        </div>
                      </div>
                      
                      <div 
                        style={{
                          ...styles.paymentOption,
                          ...styles.paymentOptionDisabled
                        }}
                      >
                        <input
                          type="radio"
                          name="paymentOption"
                          id="paymentCard"
                          value="card"
                          disabled
                          style={styles.paymentOptionRadio}
                        />
                        <div style={styles.paymentOptionIcon}>
                          <FontAwesomeIcon icon={faCreditCard} />
                        </div>
                        <div style={styles.paymentOptionContent}>
                          <h5 style={styles.paymentOptionTitle}>Paiement en ligne</h5>
                          <small style={styles.paymentOptionDescription}>Cette option sera bientôt disponible</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {/* Boutons de navigation */}
            <div style={styles.buttonGroup}>
              <div style={styles.buttonLeft}>
                {currentStep > 1 && (
                  <button
                    type="button"
                    onClick={handlePrevStep}
                    style={{
                      ...styles.button,
                      ...styles.buttonSecondary
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = styles.buttonSecondaryHover.backgroundColor;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = styles.buttonSecondary.backgroundColor;
                    }}
                  >
                    <FontAwesomeIcon icon={faArrowLeft} />
                    Précédent
                  </button>
                )}
              </div>
              
              <div style={styles.buttonRight}>
                {currentStep === 1 && (
                  <button
                    type="button"
                    onClick={() => {
                      setInitialView(true);
                      setCurrentView('booking');
                      // **Réinitialiser les états de vérification patient**
                      setPatientExists(null);
                      setExistingPatientData(null);
                      setShowPatientSelection(false);
                      setFoundPatients([]);
                    }}
                    style={{
                      ...styles.button,
                      ...styles.buttonSecondary
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = styles.buttonSecondaryHover.backgroundColor;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = styles.buttonSecondary.backgroundColor;
                    }}
                  >
                    <FontAwesomeIcon icon={faHome} />
                    Accueil
                  </button>
                )}
                
                {currentStep < 3 ? (
                  <button
                    type="button"
                    onClick={handleNextStep}
                    style={{
                      ...styles.button,
                      ...styles.buttonPrimary
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = styles.buttonPrimaryHover.backgroundColor;
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = styles.buttonPrimary.backgroundColor;
                    }}
                  >
                    Suivant
                    <FontAwesomeIcon icon={faArrowLeft} rotation={180} />
                  </button>
                ) : (
                  <button
                    type="submit"
                    disabled={loading}
                    style={{
                      ...styles.button,
                      ...styles.buttonPrimary,
                      ...(loading ? styles.buttonDisabled : {})
                    }}
                    onMouseEnter={(e) => {
                      if (!loading) {
                        e.target.style.backgroundColor = styles.buttonPrimaryHover.backgroundColor;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!loading) {
                        e.target.style.backgroundColor = styles.buttonPrimary.backgroundColor;
                      }
                    }}
                  >
                    {loading ? (
                      <>
                        <div style={styles.loadingSpinner}></div>
                        Traitement en cours...
                      </>
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faCheck} />
                        {modificationMode ? "Enregistrer les modifications" : "Confirmer le rendez-vous"}
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };

  // Vue de succès modernisée (reste identique)
  const renderSuccessView = () => {
    return (
      <div style={styles.card}>
        <div style={styles.cardBody}>
          <div style={{ textAlign: "center", padding: "20px 0" }}>
            <div style={styles.successIcon}>
              <FontAwesomeIcon icon={faCheck} />
            </div>
            
            <h3 style={styles.successTitle}>Rendez-vous confirmé !</h3>
            <p style={styles.successMessage}>
              Votre rendez-vous a été enregistré avec succès. Un SMS de confirmation a été envoyé à votre numéro.
            </p>
            
            <div style={{ maxWidth: "400px", margin: "0 auto 32px", backgroundColor: "#f8f8f8", padding: "16px", borderRadius: "8px" }}>
              <h5 style={{ fontSize: "16px", fontWeight: "600", margin: "0 0 12px", color: "#323130" }}>Code de vérification</h5>
              <div style={styles.verificationCodeDisplay}>
                {verificationCode.split('').map((char, index) => (
                  <span key={`verify-code-${index}-${char}`} style={styles.verificationCodeChar}>{char}</span>
                ))}
              </div>
              <p style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "14px", color: "#605e5c", margin: "12px 0 0" }}>
                <FontAwesomeIcon icon={faInfoCircle} style={{ color: "#0078d4" }} />
                Conservez ce code pour vérifier, modifier ou annuler votre rendez-vous
              </p>
            </div>
            
            <div style={{ maxWidth: "500px", margin: "0 auto 32px" }}>
              <div style={styles.summaryCard}>
                <div style={styles.summaryCardHeader}>
                  <div style={styles.summaryCardIcon}>
                    <FontAwesomeIcon icon={faCalendarCheck} />
                  </div>
                  <h5 style={styles.summaryCardTitle}>Détails du rendez-vous</h5>
                </div>
                
                <div style={{ padding: "8px 0" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #edebe9" }}>
                    <span style={{ fontWeight: "500" }}>Date</span>
                    <span>{formatDate(formData.dateRdv)}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #edebe9" }}>
                    <span style={{ fontWeight: "500" }}>Heure</span>
                    <span>{formData.heureRdv}</span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px solid #edebe9" }}>
                    <span style={{ fontWeight: "500" }}>Médecin</span>
                    <span>
                      {medecins.find(m => m.id === formData.medecinId)?.titre || "Dr"} {medecins.find(m => m.id === formData.medecinId)?.nom || ''}
                    </span>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0" }}>
                    <span style={{ fontWeight: "500" }}>Spécialité</span>
                    <span>
                      {medecins.find(m => m.id === formData.medecinId)?.specialite || ''}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            
            <div style={{ display: "flex", gap: "16px", justifyContent: "center" }}>
              <button
                onClick={() => {
                  setInitialView(true);
                  setCurrentView('booking');
                  setFormData({
                    nom: '',
                    dateNaissance: '',
                    email: '',
                    telephone: '',
                    dateRdv: '',
                    heureRdv: '',
                    medecinId: '',
                    motif: '',
                    statut: 'confirmé',
                    structureId: STRUCTURE_ID
                  });
                  setCurrentStep(1);
                  // **Réinitialiser les états de vérification patient**
                  setPatientExists(null);
                  setExistingPatientData(null);
                  setShowPatientSelection(false);
                  setFoundPatients([]);
                }}
                style={{
                  ...styles.button,
                  ...styles.buttonSecondary
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = styles.buttonSecondaryHover.backgroundColor;
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = styles.buttonSecondary.backgroundColor;
                }}
              >
                <FontAwesomeIcon icon={faHome} />
                Retour à l'accueil
              </button>
              
              <button
                onClick={() => {
                  setVerificationSearchCode(verificationCode);
                  setCurrentView('verification');
                  setInitialView(false);
                }}
                style={{
                  ...styles.button,
                  ...styles.buttonPrimary
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = styles.buttonPrimaryHover.backgroundColor;
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = styles.buttonPrimary.backgroundColor;
                }}
              >
                <FontAwesomeIcon icon={faSearch} />
                Vérifier mon rendez-vous
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Vue de vérification modernisée (reste identique)
  const renderVerificationView = () => {
    return (
      <div style={styles.card}>
        <div style={styles.cardBody}>
          <h3 style={{ fontSize: "22px", fontWeight: "600", margin: "0 0 24px", display: "flex", alignItems: "center", gap: "10px" }}>
            <FontAwesomeIcon icon={faSearch} style={{ color: "#0078d4" }} />
            Vérifier ou modifier un rendez-vous
          </h3>
          
          <div style={styles.card}>
            <div style={styles.cardBody}>
              <div style={{ maxWidth: "600px", margin: "0 auto" }}>
                <p style={{ fontSize: "16px", color: "#605e5c", margin: "0 0 16px" }}>
                  Entrez le code de vérification que vous avez reçu lors de la prise de rendez-vous
                </p>
                
                <div style={styles.verificationInput}>
                  <input
                    type="text"
                    placeholder="Ex: ABCD1234"
                    value={verificationSearchCode}
                    onChange={(e) => setVerificationSearchCode(e.target.value.toUpperCase())}
                    style={styles.verificationInputField}
                    onFocus={(e) => {
                      e.target.style.borderColor = styles.inputFocus.borderColor;
                      e.target.style.boxShadow = styles.inputFocus.boxShadow;
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = styles.input.border.split(' ')[2];
                      e.target.style.boxShadow = "none";
                    }}
                  />
                  <button
                    onClick={handleFindAppointmentForModification}
                    disabled={loadingVerification}
                    style={{
                      ...styles.verificationButton,
                      ...(loadingVerification ? styles.buttonDisabled : {})
                    }}
                    onMouseEnter={(e) => {
                      if (!loadingVerification) {
                        e.target.style.backgroundColor = styles.verificationButtonHover.backgroundColor;
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!loadingVerification) {
                        e.target.style.backgroundColor = styles.verificationButton.backgroundColor;
                      }
                    }}
                  >
                    {loadingVerification ? (
                      <div style={styles.loadingSpinner}></div>
                    ) : (
                      <FontAwesomeIcon icon={faSearch} />
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          
          {verificationResult && (
            <div style={styles.card}>
              <div style={styles.cardBody}>
                <h4 style={{ fontSize: "18px", fontWeight: "600", margin: "0 0 16px", display: "flex", alignItems: "center", gap: "8px" }}>
                  <FontAwesomeIcon icon={faCalendarCheck} style={{ color: "#0078d4" }} />
                  Détails du rendez-vous
                </h4>
                
                <div style={styles.appointmentDetails}>
                  <div style={styles.summaryCard}>
                    <div style={styles.summaryCardHeader}>
                      <div style={styles.summaryCardIcon}>
                        <FontAwesomeIcon icon={faUser} />
                      </div>
                      <h5 style={styles.summaryCardTitle}>Patient</h5>
                    </div>
                    <ul style={styles.summaryList}>
                      <li style={styles.summaryItem}>
                        <strong>Nom:</strong> {verificationResult.patientNom || '-'}
                      </li>
                      <li style={styles.summaryItem}>
                        <strong>Téléphone:</strong> {verificationResult.patientTelephone}
                      </li>
                      {verificationResult.patientEmail && (
                        <li style={styles.summaryItem}>
                          <strong>Email:</strong> {verificationResult.patientEmail}
                        </li>
                      )}
                      <li style={{...styles.summaryItem, ...styles.summaryItemLast}}>
                        <strong>Statut:</strong> 
                        <span style={{ 
                          color: verificationResult.statut === 'confirmé' ? '#107c10' : 
                                 verificationResult.statut === 'annulé' ? '#d83b01' : '#605e5c',
                          fontWeight: '600',
                          marginLeft: '8px'
                        }}>
                          {verificationResult.statut}
                        </span>
                      </li>
                    </ul>
                  </div>
                  
                  <div style={styles.summaryCard}>
                    <div style={styles.summaryCardHeader}>
                      <div style={styles.summaryCardIcon}>
                        <FontAwesomeIcon icon={faCalendarCheck} />
                      </div>
                      <h5 style={styles.summaryCardTitle}>Rendez-vous</h5>
                    </div>
                    <ul style={styles.summaryList}>
                      <li style={styles.summaryItem}>
                        <strong>Date:</strong> {formatDate(verificationResult.date)}
                      </li>
                      <li style={styles.summaryItem}>
                        <strong>Heure:</strong> {verificationResult.heure}
                      </li>
                      <li style={styles.summaryItem}>
                        <strong>Médecin:</strong> {verificationResult.medecinNom}
                      </li>
                      <li style={styles.summaryItem}>
                        <strong>Spécialité:</strong> {verificationResult.medecinSpecialite}
                      </li>
                      <li style={{...styles.summaryItem, ...styles.summaryItemLast}}>
                        <strong>Motif:</strong> {verificationResult.motif}
                      </li>
                    </ul>
                  </div>
                </div>
                
                {verificationResult.structureId !== STRUCTURE_ID && (
                  <div style={styles.infoBox}>
                    <div style={styles.infoBoxIcon}>
                      <FontAwesomeIcon icon={faHospital} />
                    </div>
                    <div style={styles.infoBoxContent}>
                      <h5 style={styles.infoBoxTitle}>Structure externe</h5>
                      <p style={styles.infoBoxText}>
                        <strong>Nom:</strong> {verificationResult.structureNom}
                      </p>
                    </div>
                  </div>
                )}
                
                {appointmentToModify && verificationResult.statut !== 'annulé' && new Date(verificationResult.date) >= new Date() && (
                  <div style={{ marginTop: "24px" }}>
                    <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
                      <button
                        onClick={startModification}
                        style={{
                          ...styles.button,
                          ...styles.buttonPrimary
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = styles.buttonPrimaryHover.backgroundColor;
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = styles.buttonPrimary.backgroundColor;
                        }}
                      >
                        <FontAwesomeIcon icon={faExchangeAlt} />
                        Modifier le rendez-vous
                      </button>
                      
                      <button
                        onClick={() => setCancelConfirmation(true)}
                        style={{
                          ...styles.button,
                          ...styles.buttonDanger
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = styles.buttonDangerHover.backgroundColor;
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = styles.buttonDanger.backgroundColor;
                        }}
                      >
                        <FontAwesomeIcon icon={faTimes} />
                        Annuler le rendez-vous
                      </button>
                    </div>
                    
                    {cancelConfirmation && (
                      <div style={styles.confirmDialog}>
                        <div style={styles.confirmDialogHeader}>
                          <FontAwesomeIcon icon={faTimes} style={styles.confirmDialogIcon} />
                          <h5 style={styles.confirmDialogTitle}>Confirmer l'annulation</h5>
                        </div>
                        <p style={{ margin: "0 0 16px", fontSize: "14px", color: "#605e5c" }}>
                          Êtes-vous sûr de vouloir annuler ce rendez-vous ? Cette action est irréversible.
                        </p>
                        <div style={styles.confirmDialogButtons}>
                          <button
                            onClick={() => setCancelConfirmation(false)}
                            style={{
                              ...styles.button,
                              ...styles.buttonSecondary
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = styles.buttonSecondaryHover.backgroundColor;
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = styles.buttonSecondary.backgroundColor;
                            }}
                          >
                            Non, garder le rendez-vous
                          </button>
                          <button
                            onClick={cancelAppointment}
                            disabled={loading}
                            style={{
                              ...styles.button,
                              ...styles.buttonDanger,
                              ...(loading ? styles.buttonDisabled : {})
                            }}
                            onMouseEnter={(e) => {
                              if (!loading) {
                                e.target.style.backgroundColor = styles.buttonDangerHover.backgroundColor;
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!loading) {
                                e.target.style.backgroundColor = styles.buttonDanger.backgroundColor;
                              }
                            }}
                          >
                            {loading ? (
                              <>
                                <div style={styles.loadingSpinner}></div>
                                Annulation...
                              </>
                            ) : (
                              <>
                                <FontAwesomeIcon icon={faTimes} />
                                Oui, annuler
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          )}
          
          <div style={{ textAlign: "center", marginTop: "24px" }}>
            <button
              onClick={() => {
                setInitialView(true);
                setCurrentView('booking');
                setVerificationResult(null);
                setVerificationSearchCode('');
                setAppointmentToModify(null);
                setCancelConfirmation(false);
                // **Réinitialiser les états de vérification patient**
                setPatientExists(null);
                setExistingPatientData(null);
                setShowPatientSelection(false);
                setFoundPatients([]);
              }}
              style={{
                ...styles.button,
                ...styles.buttonSecondary
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = styles.buttonSecondaryHover.backgroundColor;
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = styles.buttonSecondary.backgroundColor;
              }}
            >
              <FontAwesomeIcon icon={faHome} />
              Retour à l'accueil
            </button>
          </div>
        </div>
      </div>
    );
  };

  // Modal pour iframe
  const renderIframeModal = () => {
    if (!showIframe) return null;
    
    return (
      <div style={styles.modalOverlay}>
        <div style={styles.modalContent}>
          <div style={styles.modalHeader}>
            <h4 style={styles.modalTitle}>{iframeTitle}</h4>
            <button
              onClick={() => setShowIframe(false)}
              style={styles.modalCloseButton}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = styles.modalCloseButtonHover.backgroundColor;
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "transparent";
              }}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>
          <div style={styles.modalBody}>
            <iframe
              src={iframeUrl}
              style={styles.iframe}
              title={iframeTitle}
            ></iframe>
          </div>
        </div>
      </div>
    );
  };

  // Affichage des messages d'alerte
  const renderAlert = () => {
    if (!message.text) return null;
    
    return (
      <div style={{
        ...styles.alert,
        ...(message.type === 'success' ? styles.alertSuccess : 
           message.type === 'error' ? styles.alertError : styles.alertInfo)
      }}>
        <FontAwesomeIcon 
          icon={message.type === 'success' ? faCheck : 
                message.type === 'error' ? faTimes : faInfoCircle} 
          style={styles.alertIcon} 
        />
        <div style={styles.alertContent}>
          {message.text}
        </div>
        <button
          onClick={() => setMessage({ text: '', type: '' })}
          style={styles.alertCloseButton}
          onMouseEnter={(e) => {
            e.target.style.opacity = "1";
          }}
          onMouseLeave={(e) => {
            e.target.style.opacity = "0.7";
          }}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>
    );
  };

  // Rendu principal de l'application
  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      
      <div style={styles.appWrapper}>
        {/* En-tête de l'application */}
        <header style={styles.header}>
          <div style={styles.headerTitle}>
            <h1 style={styles.headerTitleText}>
              <span style={styles.headerTitleSpan}>SAM</span> Digitale
            </h1>
          </div>
          
          <div style={styles.headerLinks}>
           
            <a 
              href="tel:+221770977918" 
              style={styles.headerLink}
              title="Contacter le service client "
            >
              <FontAwesomeIcon icon={faPhone} />
            
            </a>
          </div>
        </header>
        
        {/* Messages d'alerte */}
        {renderAlert()}
        
        {/* Contenu principal */}
        <main style={styles.mainContent}>
          {initialView && renderInitialView()}
          {!initialView && currentView === 'booking' && renderBookingForm()}
          {!initialView && currentView === 'success' && renderSuccessView()}
          {!initialView && currentView === 'verification' && renderVerificationView()}
        </main>
        
        {/* Modal iframe */}
        {renderIframeModal()}
      </div>
    </div>
  );
};

export default Quick;
